var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _linearGradient25, _linearGradient26, _linearGradient27, _linearGradient28, _linearGradient29, _linearGradient30, _linearGradient31, _linearGradient32, _linearGradient33, _linearGradient34, _linearGradient35, _linearGradient36, _linearGradient37, _linearGradient38, _linearGradient39, _linearGradient40, _linearGradient41, _linearGradient42, _linearGradient43, _linearGradient44, _linearGradient45, _linearGradient46, _linearGradient47, _linearGradient48, _linearGradient49, _linearGradient50, _linearGradient51, _linearGradient52, _linearGradient53, _linearGradient54, _linearGradient55, _linearGradient56, _linearGradient57, _linearGradient58, _linearGradient59, _linearGradient60, _linearGradient61, _linearGradient62, _linearGradient63, _linearGradient64, _linearGradient65, _linearGradient66, _linearGradient67, _linearGradient68, _linearGradient69, _linearGradient70, _linearGradient71, _linearGradient72, _linearGradient73, _linearGradient74, _linearGradient75, _linearGradient76, _linearGradient77, _linearGradient78, _linearGradient79, _linearGradient80, _linearGradient81, _linearGradient82, _linearGradient83, _linearGradient84, _linearGradient85, _linearGradient86, _linearGradient87, _linearGradient88, _linearGradient89, _linearGradient90, _linearGradient91, _linearGradient92, _linearGradient93, _linearGradient94, _linearGradient95, _linearGradient96, _linearGradient97, _linearGradient98, _linearGradient99, _linearGradient100, _linearGradient101, _linearGradient102, _linearGradient103, _linearGradient104, _linearGradient105, _linearGradient106, _linearGradient107, _linearGradient108, _linearGradient109, _linearGradient110, _linearGradient111, _linearGradient112, _linearGradient113, _linearGradient114, _linearGradient115, _linearGradient116, _linearGradient117, _linearGradient118, _linearGradient119, _linearGradient120, _linearGradient121, _linearGradient122, _linearGradient123, _linearGradient124, _linearGradient125, _linearGradient126, _linearGradient127, _linearGradient128, _linearGradient129, _linearGradient130, _linearGradient131, _linearGradient132, _linearGradient133, _linearGradient134, _linearGradient135, _linearGradient136, _linearGradient137, _linearGradient138, _linearGradient139, _linearGradient140, _linearGradient141, _linearGradient142, _linearGradient143, _linearGradient144, _linearGradient145, _linearGradient146, _linearGradient147, _linearGradient148, _linearGradient149, _linearGradient150, _linearGradient151, _linearGradient152, _linearGradient153, _linearGradient154, _linearGradient155, _linearGradient156, _linearGradient157, _linearGradient158, _linearGradient159, _linearGradient160, _linearGradient161, _linearGradient162, _linearGradient163, _linearGradient164, _linearGradient165, _linearGradient166, _linearGradient167, _linearGradient168, _linearGradient169, _linearGradient170, _linearGradient171, _linearGradient172, _linearGradient173, _linearGradient174, _linearGradient175, _linearGradient176, _linearGradient177, _linearGradient178, _linearGradient179, _linearGradient180, _linearGradient181, _linearGradient182, _linearGradient183, _linearGradient184, _linearGradient185, _linearGradient186, _linearGradient187, _linearGradient188, _linearGradient189, _linearGradient190, _linearGradient191, _linearGradient192, _linearGradient193, _linearGradient194, _linearGradient195, _linearGradient196, _style, _path, _path2, _path3, _path4, _path5, _path6, _rect, _rect2, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _g, _g2, _g3, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeroImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Illustration",
    viewBox: "0 0 1011.49 661.71",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 97.33,
    x2: 1086.66,
    y1: 387.18,
    y2: 387.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b37cff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f895e7"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient",
    id: "linear-gradient-2",
    x1: 138.86,
    x2: 1105.75,
    y1: 392.32,
    y2: 392.32
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 287.3,
    x2: 548,
    y1: 534.37,
    y2: 228.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e92556"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f9c342"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 168.75,
    x2: 312.37,
    y1: 270.96,
    y2: 625.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cb236d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4c246d"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-3",
    id: "linear-gradient-5",
    x1: 725.14,
    x2: 868.76,
    y1: 230.43,
    y2: 585.25,
    gradientTransform: "rotate(53.64 789.282 417.777)"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -1195.38,
    x2: -1189.33,
    y1: 627.46,
    y2: 758.61,
    gradientTransform: "matrix(-1 0 0 1 -740.25 -69.15)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#233894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dd397a"
  }))), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -1467.34,
    x2: -1447.19,
    y1: 605,
    y2: 683.75,
    gradientTransform: "matrix(-1 0 0 1 -740.25 -69.15)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2b3582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#150e42"
  }))), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: -1211.11,
    x2: -1182.94,
    y1: 506.67,
    y2: 1116.96,
    gradientTransform: "matrix(-1 0 0 1 -646 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#53d8ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3840f7"
  }))), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-8",
    id: "linear-gradient-9",
    x1: -1238.58,
    x2: -1108.28,
    y1: 347.13,
    y2: 856.27
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: -850.77,
    x2: -829.48,
    y1: 565.11,
    y2: 1026.38,
    gradientTransform: "matrix(-1 0 0 1 -646 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fdf53f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d93c65"
  }))), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-8",
    id: "linear-gradient-11",
    x1: -857.87,
    x2: -659.66,
    y1: 619.86,
    y2: 624.85
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-8",
    id: "linear-gradient-12",
    x1: -869.16,
    x2: -719.16,
    y1: 458.28,
    y2: 462.05
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-8",
    id: "linear-gradient-13",
    x1: -792.04,
    x2: -741.16,
    y1: 459.09,
    y2: 460.37
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-10",
    id: "linear-gradient-14",
    x1: -826,
    x2: -918.68,
    y1: 484.05,
    y2: 531.88,
    gradientTransform: "matrix(-1 0 0 1 -740.25 -69.15)"
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-10",
    id: "linear-gradient-15",
    x1: -766.48,
    x2: -987.48,
    y1: 297.67,
    y2: 411.74
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-7",
    id: "linear-gradient-16",
    x1: -916.65,
    x2: -792.15,
    y1: 642.13,
    y2: 642.13
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: -854.4,
    x2: -854.4,
    y1: 562.98,
    y2: 776.77,
    gradientTransform: "matrix(-.05 -1 -1 .05 810.97 -240.61)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5ab6ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2f68e3"
  }))), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-7",
    id: "linear-gradient-18",
    x1: -831.55,
    x2: -894.83,
    y1: 604.93,
    y2: 708.61,
    gradientTransform: "matrix(-.97 -.23 -.23 .97 -477.46 -177.53)"
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-7",
    id: "linear-gradient-19",
    x1: -1300.46,
    x2: -1175.95,
    y1: 642.13,
    y2: 642.13
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-17",
    id: "linear-gradient-20",
    x1: -1238.21,
    x2: -1238.21,
    y1: 562.98,
    y2: 776.77,
    gradientTransform: "matrix(-.06 -1 -1 .06 1155.65 -633.81)"
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-7",
    id: "linear-gradient-21",
    x1: -1215.36,
    x2: -1278.64,
    y1: 604.93,
    y2: 708.61,
    gradientTransform: "scale(-1 1) rotate(-7 -929.51 -4712.629)"
  })), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-7",
    id: "linear-gradient-22",
    x1: -1442.87,
    x2: -1318.36,
    y1: 642.13,
    y2: 642.13
  })), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-17",
    id: "linear-gradient-23",
    x1: -1380.62,
    x2: -1380.62,
    y1: 562.98,
    y2: 776.77,
    gradientTransform: "matrix(-.05 -1 -1 .05 1306.82 -768.9)"
  })), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-7",
    id: "linear-gradient-24",
    x1: -1357.77,
    x2: -1421.05,
    y1: 604.93,
    y2: 708.61,
    gradientTransform: "matrix(-.97 -.23 -.23 .97 -463.67 -297.24)"
  })), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-10",
    id: "linear-gradient-25",
    x1: -779.75,
    x2: -760.5,
    y1: 600.22,
    y2: 554.21,
    gradientTransform: "matrix(-1 0 0 1 -740.25 -69.15)"
  })), _linearGradient26 || (_linearGradient26 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-17",
    id: "linear-gradient-26",
    x1: -879.17,
    x2: -1202.62,
    y1: 529.69,
    y2: 696.63,
    gradientTransform: "matrix(-1 0 0 1 -646 0)"
  })), _linearGradient27 || (_linearGradient27 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-10",
    id: "linear-gradient-27",
    x1: 250.54,
    x2: 592.33,
    y1: 574.09,
    y2: 812.55
  })), _linearGradient28 || (_linearGradient28 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-7",
    id: "linear-gradient-28",
    x1: 339.47,
    x2: 296.98,
    y1: 638.56,
    y2: 700.3
  })), _linearGradient29 || (_linearGradient29 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-7",
    id: "linear-gradient-29",
    x1: 340.99,
    x2: 298.51,
    y1: 639.61,
    y2: 701.35
  })), _linearGradient30 || (_linearGradient30 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-7",
    id: "linear-gradient-30",
    x1: 342.84,
    x2: 300.35,
    y1: 640.88,
    y2: 702.62
  })), _linearGradient31 || (_linearGradient31 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-7",
    id: "linear-gradient-31",
    x1: 346.02,
    x2: 303.54,
    y1: 643.08,
    y2: 704.81
  })), _linearGradient32 || (_linearGradient32 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-7",
    id: "linear-gradient-32",
    x1: 348.13,
    x2: 305.64,
    y1: 644.52,
    y2: 706.26
  })), _linearGradient33 || (_linearGradient33 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-7",
    id: "linear-gradient-33",
    x1: 349.43,
    x2: 306.95,
    y1: 645.42,
    y2: 707.16
  })), _linearGradient34 || (_linearGradient34 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-7",
    id: "linear-gradient-34",
    x1: 337.28,
    x2: 294.79,
    y1: 637.06,
    y2: 698.79
  })), _linearGradient35 || (_linearGradient35 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-10",
    id: "linear-gradient-35",
    x1: 289.66,
    x2: 529.69,
    y1: 513.09,
    y2: 680.55
  })), _linearGradient36 || (_linearGradient36 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-7",
    id: "linear-gradient-36",
    x1: 352.11,
    x2: 322.27,
    y1: 558.36,
    y2: 601.72
  })), _linearGradient37 || (_linearGradient37 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-7",
    id: "linear-gradient-37",
    x1: 353.18,
    x2: 323.35,
    y1: 559.1,
    y2: 602.46
  })), _linearGradient38 || (_linearGradient38 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-7",
    id: "linear-gradient-38",
    x1: 354.48,
    x2: 324.64,
    y1: 559.99,
    y2: 603.35
  })), _linearGradient39 || (_linearGradient39 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-7",
    id: "linear-gradient-39",
    x1: 356.72,
    x2: 326.88,
    y1: 561.53,
    y2: 604.89
  })), _linearGradient40 || (_linearGradient40 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-7",
    id: "linear-gradient-40",
    x1: 358.19,
    x2: 328.36,
    y1: 562.55,
    y2: 605.9
  })), _linearGradient41 || (_linearGradient41 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-7",
    id: "linear-gradient-41",
    x1: 359.11,
    x2: 329.27,
    y1: 563.18,
    y2: 606.54
  })), _linearGradient42 || (_linearGradient42 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-7",
    id: "linear-gradient-42",
    x1: 350.57,
    x2: 320.74,
    y1: 557.31,
    y2: 600.66
  })), _linearGradient43 || (_linearGradient43 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-10",
    id: "linear-gradient-43",
    x1: 434.97,
    x2: 776.76,
    y1: 573.17,
    y2: 811.62
  })), _linearGradient44 || (_linearGradient44 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-7",
    id: "linear-gradient-44",
    x1: 523.9,
    x2: 481.41,
    y1: 637.63,
    y2: 699.37
  })), _linearGradient45 || (_linearGradient45 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-7",
    id: "linear-gradient-45",
    x1: 525.42,
    x2: 482.94,
    y1: 638.68,
    y2: 700.42
  })), _linearGradient46 || (_linearGradient46 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-7",
    id: "linear-gradient-46",
    x1: 527.27,
    x2: 484.78,
    y1: 639.95,
    y2: 701.69
  })), _linearGradient47 || (_linearGradient47 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-7",
    id: "linear-gradient-47",
    x1: 530.46,
    x2: 487.97,
    y1: 642.15,
    y2: 703.88
  })), _linearGradient48 || (_linearGradient48 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-7",
    id: "linear-gradient-48",
    x1: 532.56,
    x2: 490.07,
    y1: 643.59,
    y2: 705.33
  })), _linearGradient49 || (_linearGradient49 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-7",
    id: "linear-gradient-49",
    x1: 533.86,
    x2: 491.38,
    y1: 644.49,
    y2: 706.23
  })), _linearGradient50 || (_linearGradient50 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-7",
    id: "linear-gradient-50",
    x1: 521.71,
    x2: 479.22,
    y1: 636.13,
    y2: 697.87
  })), _linearGradient51 || (_linearGradient51 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-10",
    id: "linear-gradient-51",
    x1: 474.09,
    x2: 714.12,
    y1: 512.16,
    y2: 679.62
  })), _linearGradient52 || (_linearGradient52 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-7",
    id: "linear-gradient-52",
    x1: 536.54,
    x2: 506.7,
    y1: 557.43,
    y2: 600.79
  })), _linearGradient53 || (_linearGradient53 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-7",
    id: "linear-gradient-53",
    x1: 537.61,
    x2: 507.78,
    y1: 558.17,
    y2: 601.53
  })), _linearGradient54 || (_linearGradient54 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-7",
    id: "linear-gradient-54",
    x1: 538.91,
    x2: 509.07,
    y1: 559.06,
    y2: 602.42
  })), _linearGradient55 || (_linearGradient55 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-7",
    id: "linear-gradient-55",
    x1: 541.15,
    x2: 511.31,
    y1: 560.6,
    y2: 603.96
  })), _linearGradient56 || (_linearGradient56 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-7",
    id: "linear-gradient-56",
    x1: 542.62,
    x2: 512.79,
    y1: 561.62,
    y2: 604.98
  })), _linearGradient57 || (_linearGradient57 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-7",
    id: "linear-gradient-57",
    x1: 543.54,
    x2: 513.7,
    y1: 562.25,
    y2: 605.61
  })), _linearGradient58 || (_linearGradient58 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-7",
    id: "linear-gradient-58",
    x1: 535.01,
    x2: 505.17,
    y1: 556.38,
    y2: 599.73
  })), _linearGradient59 || (_linearGradient59 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-59",
    x1: 478.18,
    x2: 624.86,
    y1: 182.94,
    y2: 182.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a737d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ef497a"
  }))), _linearGradient60 || (_linearGradient60 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-59",
    id: "linear-gradient-60",
    x1: 366.41,
    x2: 466.32,
    y1: 159.46,
    y2: 159.46
  })), _linearGradient61 || (_linearGradient61 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-7",
    id: "linear-gradient-61",
    x1: 851.12,
    x2: 832.15,
    y1: 60.06,
    y2: 129.02
  })), _linearGradient62 || (_linearGradient62 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-7",
    id: "linear-gradient-62",
    x1: 857.54,
    x2: 837.42,
    y1: 77.05,
    y2: 150.16
  })), _linearGradient63 || (_linearGradient63 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-7",
    id: "linear-gradient-63",
    x1: 850.14,
    x2: 833.37,
    y1: 70.34,
    y2: 131.31
  })), _linearGradient64 || (_linearGradient64 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-7",
    id: "linear-gradient-64",
    x1: 808.11,
    x2: 887.79,
    y1: 164.35,
    y2: 164.35
  })), _linearGradient65 || (_linearGradient65 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-8",
    id: "linear-gradient-65",
    x1: 868.68,
    x2: 1048.19,
    y1: 220.04,
    y2: 345.29
  })), _linearGradient66 || (_linearGradient66 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-66",
    x1: 824.81,
    x2: 879.34,
    y1: 185.55,
    y2: 223.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e40045"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5c0e16"
  }))), _linearGradient67 || (_linearGradient67 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-66",
    id: "linear-gradient-67",
    x1: 821.43,
    x2: 886.86,
    y1: 182.49,
    y2: 228.14
  })), _linearGradient68 || (_linearGradient68 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-4",
    id: "linear-gradient-68",
    x1: 865.66,
    x2: 1058.15,
    y1: 85.94,
    y2: 220.24
  })), _linearGradient69 || (_linearGradient69 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-4",
    id: "linear-gradient-69",
    x1: 918.81,
    x2: 919.51,
    y1: 110,
    y2: 77.65
  })), _linearGradient70 || (_linearGradient70 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-4",
    id: "linear-gradient-70",
    x1: 938.73,
    x2: 927.77,
    y1: 126.41,
    y2: 166.24
  })), _linearGradient71 || (_linearGradient71 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-4",
    id: "linear-gradient-71",
    x1: 956.31,
    x2: 947.29,
    y1: 126.83,
    y2: 159.64
  })), _linearGradient72 || (_linearGradient72 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-4",
    id: "linear-gradient-72",
    x1: 972.64,
    x2: 965.35,
    y1: 124.36,
    y2: 150.84
  })), _linearGradient73 || (_linearGradient73 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-59",
    id: "linear-gradient-73",
    x1: 744.75,
    x2: 902.75,
    y1: 473.79,
    y2: 473.79
  })), _linearGradient74 || (_linearGradient74 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient",
    id: "linear-gradient-74",
    x1: 926.25,
    x2: 926.25,
    y1: 649.67,
    y2: 370.02
  })), _linearGradient75 || (_linearGradient75 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient",
    id: "linear-gradient-75",
    x1: 909.75,
    x2: 909.75,
    y1: 647.31,
    y2: 371.17
  })), _linearGradient76 || (_linearGradient76 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient",
    id: "linear-gradient-76",
    x1: 945.75,
    x2: 945.75,
    y1: 647.48,
    y2: 371.35
  })), _linearGradient77 || (_linearGradient77 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-4",
    id: "linear-gradient-77",
    x1: 1329.48,
    x2: 1206.47,
    y1: 695.31,
    y2: 829.11,
    gradientTransform: "translate(-980.28)"
  })), _linearGradient78 || (_linearGradient78 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-78",
    x1: 309.28,
    x2: 320.2,
    y1: 705.24,
    y2: 705.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e2be76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f4cbab"
  }))), _linearGradient79 || (_linearGradient79 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-7",
    id: "linear-gradient-79",
    x1: 1318.97,
    x2: 1250.71,
    y1: 701.83,
    y2: 521.17,
    gradientTransform: "translate(-980.28)"
  })), _linearGradient80 || (_linearGradient80 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-4",
    id: "linear-gradient-80",
    x1: 1301.89,
    x2: 1178.88,
    y1: 669.94,
    y2: 803.74,
    gradientTransform: "translate(-980.28)"
  })), _linearGradient81 || (_linearGradient81 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-78",
    id: "linear-gradient-81",
    x1: 269.9,
    x2: 279.33,
    y1: 704.68,
    y2: 704.68
  })), _linearGradient82 || (_linearGradient82 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-7",
    id: "linear-gradient-82",
    x1: 1240.01,
    x2: 1291.3,
    y1: 620.52,
    y2: 620.52,
    gradientTransform: "translate(-980.28)"
  })), _linearGradient83 || (_linearGradient83 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-66",
    id: "linear-gradient-83",
    x1: 1225.42,
    x2: 1397.35,
    y1: 522.16,
    y2: 398.43,
    gradientTransform: "translate(-980.28)"
  })), _linearGradient84 || (_linearGradient84 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-78",
    id: "linear-gradient-84",
    x1: 354.24,
    x2: 410.06,
    y1: 420.19,
    y2: 420.19
  })), _linearGradient85 || (_linearGradient85 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-78",
    id: "linear-gradient-85",
    x1: 403.63,
    x2: 422.36,
    y1: 375.59,
    y2: 375.59
  })), _linearGradient86 || (_linearGradient86 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-78",
    id: "linear-gradient-86",
    x1: 407.17,
    x2: 414.91,
    y1: 379.68,
    y2: 379.68
  })), _linearGradient87 || (_linearGradient87 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-66",
    id: "linear-gradient-87",
    x1: 1202.77,
    x2: 1374.69,
    y1: 490.68,
    y2: 366.95,
    gradientTransform: "translate(-980.28)"
  })), _linearGradient88 || (_linearGradient88 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-78",
    id: "linear-gradient-88",
    x1: 232.09,
    x2: 302.73,
    y1: 499.26,
    y2: 499.26
  })), _linearGradient89 || (_linearGradient89 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-89",
    x1: 1304.38,
    x2: 1343.22,
    y1: 449.04,
    y2: 610.88,
    gradientTransform: "translate(-980.28)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cfffb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9bfffa"
  }))), _linearGradient90 || (_linearGradient90 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-8",
    id: "linear-gradient-90",
    x1: 1328.7,
    x2: 1320.43,
    y1: 423.53,
    y2: 459.85,
    gradientTransform: "translate(-980.28)"
  })), _linearGradient91 || (_linearGradient91 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-8",
    id: "linear-gradient-91",
    x1: 1324.37,
    x2: 1320.42,
    y1: 438.77,
    y2: 462.5,
    gradientTransform: "translate(-980.28)"
  })), _linearGradient92 || (_linearGradient92 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-92",
    x1: 1277.77,
    x2: 1299.77,
    y1: 491.85,
    y2: 491.85,
    gradientTransform: "translate(-980.28)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e4bf82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e4bf82"
  }))), _linearGradient93 || (_linearGradient93 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-78",
    id: "linear-gradient-93",
    x1: 286.33,
    x2: 314.26,
    y1: 423.74,
    y2: 423.74
  })), _linearGradient94 || (_linearGradient94 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-78",
    id: "linear-gradient-94",
    x1: 292.01,
    x2: 324.46,
    y1: 400.24,
    y2: 400.24
  })), _linearGradient95 || (_linearGradient95 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-7",
    id: "linear-gradient-95",
    x1: -4956.03,
    x2: -4947.3,
    y1: -1238.97,
    y2: -1189.18,
    gradientTransform: "matrix(.75 -.67 .67 .75 4796.17 -2008.45)"
  })), _linearGradient96 || (_linearGradient96 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-78",
    id: "linear-gradient-96",
    x1: 293.54,
    x2: 303.5,
    y1: 403.63,
    y2: 403.63
  })), _linearGradient97 || (_linearGradient97 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-8",
    id: "linear-gradient-97",
    x1: 13382.33,
    x2: 13408.31,
    y1: 720.52,
    y2: 720.52,
    gradientTransform: "translate(-12989.11)"
  })), _linearGradient98 || (_linearGradient98 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-98",
    x1: 13384.97,
    x2: 13395.5,
    y1: 708.45,
    y2: 708.45,
    gradientTransform: "translate(-12989.11)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9b776"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f47960"
  }))), _linearGradient99 || (_linearGradient99 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-8",
    id: "linear-gradient-99",
    x1: 13437.58,
    x2: 13478.35,
    y1: 720.11,
    y2: 720.11,
    gradientTransform: "translate(-12989.11)"
  })), _linearGradient100 || (_linearGradient100 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-98",
    id: "linear-gradient-100",
    x1: 13438.2,
    x2: 13448.68,
    y1: 703.77,
    y2: 703.77
  })), _linearGradient101 || (_linearGradient101 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-7",
    id: "linear-gradient-101",
    x1: 13378.42,
    x2: 13449.86,
    y1: 610.82,
    y2: 610.82,
    gradientTransform: "translate(-12989.11)"
  })), _linearGradient102 || (_linearGradient102 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-66",
    id: "linear-gradient-102",
    x1: -7198.27,
    x2: -7155.83,
    y1: 408.09,
    y2: 475.55,
    gradientTransform: "matrix(-1 0 0 1 -6697.72 0)"
  })), _linearGradient103 || (_linearGradient103 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-98",
    id: "linear-gradient-103",
    x1: 13508.31,
    x2: 13547.25,
    y1: 396.94,
    y2: 396.94
  })), _linearGradient104 || (_linearGradient104 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-66",
    id: "linear-gradient-104",
    x1: -7182.33,
    x2: -6987.1,
    y1: 459.87,
    y2: 610.43,
    gradientTransform: "matrix(-1 0 0 1 -6697.72 0)"
  })), _linearGradient105 || (_linearGradient105 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-98",
    id: "linear-gradient-105",
    x1: 13596.49,
    x2: 13512.35,
    y1: 405.43,
    y2: 510.12
  })), _linearGradient106 || (_linearGradient106 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-98",
    id: "linear-gradient-106",
    x1: 13612.45,
    x2: 13528.3,
    y1: 418.26,
    y2: 522.94
  })), _linearGradient107 || (_linearGradient107 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-98",
    id: "linear-gradient-107",
    x1: 13501.83,
    x2: 13420.33,
    y1: 342.16,
    y2: 491.91
  })), _linearGradient108 || (_linearGradient108 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-98",
    id: "linear-gradient-108",
    x1: 10556.49,
    x2: 10520.47,
    y1: 10864.38,
    y2: 10912.03,
    gradientTransform: "rotate(-35.22 -11011.318 21479.178)"
  })), _linearGradient109 || (_linearGradient109 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-7",
    id: "linear-gradient-109",
    x1: -7192.47,
    x2: -7148.68,
    y1: 366.16,
    y2: 447.47,
    gradientTransform: "matrix(-1 0 0 1 -6697.72 0)"
  })), _linearGradient110 || (_linearGradient110 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-98",
    id: "linear-gradient-110",
    x1: 10503.73,
    x2: 10532.62,
    y1: 10902.11,
    y2: 10872.47,
    gradientTransform: "rotate(-35.22 -11011.318 21479.178)"
  })), _linearGradient111 || (_linearGradient111 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-10",
    id: "linear-gradient-111",
    x1: -76.75,
    x2: 161.71,
    y1: -410.47,
    y2: -244.11,
    gradientTransform: "rotate(70.97 -211.401 429.896)"
  })), _linearGradient112 || (_linearGradient112 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-7",
    id: "linear-gradient-112",
    x1: -14.71,
    x2: -44.35,
    y1: -365.5,
    y2: -322.42,
    gradientTransform: "rotate(70.97 -211.401 429.896)"
  })), _linearGradient113 || (_linearGradient113 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-7",
    id: "linear-gradient-113",
    x1: -13.64,
    x2: -43.28,
    y1: -364.76,
    y2: -321.69,
    gradientTransform: "rotate(70.97 -211.401 429.896)"
  })), _linearGradient114 || (_linearGradient114 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-7",
    id: "linear-gradient-114",
    x1: -12.36,
    x2: -42,
    y1: -363.88,
    y2: -320.81,
    gradientTransform: "rotate(70.97 -211.401 429.896)"
  })), _linearGradient115 || (_linearGradient115 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-7",
    id: "linear-gradient-115",
    x1: -10.13,
    x2: -39.77,
    y1: -362.35,
    y2: -319.28,
    gradientTransform: "rotate(70.97 -211.401 429.896)"
  })), _linearGradient116 || (_linearGradient116 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-7",
    id: "linear-gradient-116",
    x1: -8.67,
    x2: -38.31,
    y1: -361.34,
    y2: -318.27,
    gradientTransform: "rotate(70.97 -211.401 429.896)"
  })), _linearGradient117 || (_linearGradient117 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-7",
    id: "linear-gradient-117",
    x1: -7.76,
    x2: -37.4,
    y1: -360.71,
    y2: -317.64,
    gradientTransform: "rotate(70.97 -211.401 429.896)"
  })), _linearGradient118 || (_linearGradient118 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-7",
    id: "linear-gradient-118",
    x1: -16.23,
    x2: -45.87,
    y1: -366.54,
    y2: -323.47,
    gradientTransform: "rotate(70.97 -211.401 429.896)"
  })), _linearGradient119 || (_linearGradient119 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-8",
    id: "linear-gradient-119",
    x1: -1729.73,
    x2: -1829.69,
    y1: -614.56,
    y2: -675.14,
    gradientTransform: "matrix(.99 .16 -.32 .87 2243.65 954.14)"
  })), _linearGradient120 || (_linearGradient120 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-8",
    id: "linear-gradient-120",
    x1: -1785.21,
    x2: -1899.6,
    y1: -636.96,
    y2: -757.91,
    gradientTransform: "matrix(.99 .16 -.32 .87 2337.9 1023.29)"
  })), _linearGradient121 || (_linearGradient121 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-8",
    id: "linear-gradient-121",
    x1: -1737.03,
    x2: -1830.41,
    y1: -615.56,
    y2: -672.16,
    gradientTransform: "matrix(.99 .16 -.32 .87 2243.65 954.14)"
  })), _linearGradient122 || (_linearGradient122 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-8",
    id: "linear-gradient-122",
    x1: -702.94,
    x2: -660.27,
    y1: -500.93,
    y2: -513.29,
    gradientTransform: "matrix(-.99 -.16 -.16 .99 -82.91 492.86)"
  })), _linearGradient123 || (_linearGradient123 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-123",
    x1: 2436.87,
    x2: 2438.41,
    y1: 796.89,
    y2: 750.73,
    gradientTransform: "translate(-1620.19)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7c27dd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2b41d9"
  }))), _linearGradient124 || (_linearGradient124 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-8",
    id: "linear-gradient-124",
    x1: 2491.72,
    x2: 2396.6,
    y1: 678.74,
    y2: 753.43,
    gradientTransform: "translate(-1620.19)"
  })), _linearGradient125 || (_linearGradient125 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-98",
    id: "linear-gradient-125",
    x1: -271.54,
    x2: -276.7,
    y1: 679.88,
    y2: 724.94,
    gradientTransform: "matrix(-1 0 0 1 543.31 0)"
  })), _linearGradient126 || (_linearGradient126 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-8",
    id: "linear-gradient-126",
    x1: -183.88,
    x2: -275.87,
    y1: 700.9,
    y2: 773.13,
    gradientTransform: "matrix(-1 0 0 1 543.31 0)"
  })), _linearGradient127 || (_linearGradient127 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-123",
    id: "linear-gradient-127",
    x1: -210.41,
    x2: -208.87,
    y1: 825.44,
    y2: 779.28,
    gradientTransform: "matrix(-1 0 0 1 543.31 0)"
  })), _linearGradient128 || (_linearGradient128 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-98",
    id: "linear-gradient-128",
    x1: -217.15,
    x2: -221.98,
    y1: 685.65,
    y2: 727.8,
    gradientTransform: "matrix(-1 0 0 1 543.31 0)"
  })), _linearGradient129 || (_linearGradient129 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-7",
    id: "linear-gradient-129",
    x1: -2058.8,
    x2: -2053.01,
    y1: 682.96,
    y2: 501.42,
    gradientTransform: "matrix(-1 0 0 1 -1268.53 0)"
  })), _linearGradient130 || (_linearGradient130 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-4",
    id: "linear-gradient-130",
    x1: -2064.61,
    x2: -2071.67,
    y1: 403.13,
    y2: 557.3,
    gradientTransform: "matrix(-1 0 0 1 -1268.53 0)"
  })), _linearGradient131 || (_linearGradient131 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-98",
    id: "linear-gradient-131",
    x1: -2079.69,
    x2: -2056.54,
    y1: 394.23,
    y2: 394.23,
    gradientTransform: "matrix(-1 0 0 1 -1268.53 0)"
  })), _linearGradient132 || (_linearGradient132 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-98",
    id: "linear-gradient-132",
    x1: 394.6,
    x2: 440.09,
    y1: -1920.75,
    y2: -1931.82,
    gradientTransform: "scale(-1 1) rotate(-26 1829.6 -4006.386)"
  })), _linearGradient133 || (_linearGradient133 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-7",
    id: "linear-gradient-133",
    x1: -2471.58,
    x2: -2424.73,
    y1: -1244.41,
    y2: -1244.41,
    gradientTransform: "scale(-1 1) rotate(-26 1829.6 -4006.386)"
  })), _linearGradient134 || (_linearGradient134 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-98",
    id: "linear-gradient-134",
    x1: 393.02,
    x2: 438.51,
    y1: -1927.34,
    y2: -1938.41,
    gradientTransform: "scale(-1 1) rotate(-26 1829.6 -4006.386)"
  })), _linearGradient135 || (_linearGradient135 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-98",
    id: "linear-gradient-135",
    x1: -2112.54,
    x2: -2119.6,
    y1: 400.94,
    y2: 555.11,
    gradientTransform: "matrix(-1 0 0 1 -1268.53 0)"
  })), _linearGradient136 || (_linearGradient136 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-98",
    id: "linear-gradient-136",
    x1: -2005.96,
    x2: -2013.02,
    y1: 405.82,
    y2: 559.99,
    gradientTransform: "matrix(-1 0 0 1 -1268.53 0)"
  })), _linearGradient137 || (_linearGradient137 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-98",
    id: "linear-gradient-137",
    x1: 834.6,
    x2: 817.3,
    y1: 517.63,
    y2: 532.4
  })), _linearGradient138 || (_linearGradient138 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-98",
    id: "linear-gradient-138",
    x1: 767.6,
    x2: 750.3,
    y1: 517.63,
    y2: 532.4
  })), _linearGradient139 || (_linearGradient139 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-10",
    id: "linear-gradient-139",
    x1: 696.7,
    x2: 936.73,
    y1: 419.07,
    y2: 586.53
  })), _linearGradient140 || (_linearGradient140 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-7",
    id: "linear-gradient-140",
    x1: 759.15,
    x2: 729.32,
    y1: 464.34,
    y2: 507.7
  })), _linearGradient141 || (_linearGradient141 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-7",
    id: "linear-gradient-141",
    x1: 760.23,
    x2: 730.39,
    y1: 465.08,
    y2: 508.44
  })), _linearGradient142 || (_linearGradient142 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-7",
    id: "linear-gradient-142",
    x1: 761.52,
    x2: 731.68,
    y1: 465.97,
    y2: 509.33
  })), _linearGradient143 || (_linearGradient143 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-7",
    id: "linear-gradient-143",
    x1: 763.76,
    x2: 733.92,
    y1: 467.51,
    y2: 510.87
  })), _linearGradient144 || (_linearGradient144 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-7",
    id: "linear-gradient-144",
    x1: 765.24,
    x2: 735.4,
    y1: 468.53,
    y2: 511.88
  })), _linearGradient145 || (_linearGradient145 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-7",
    id: "linear-gradient-145",
    x1: 766.15,
    x2: 736.32,
    y1: 469.16,
    y2: 512.51
  })), _linearGradient146 || (_linearGradient146 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-7",
    id: "linear-gradient-146",
    x1: 757.62,
    x2: 727.78,
    y1: 463.29,
    y2: 506.64
  })), _linearGradient147 || (_linearGradient147 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-98",
    id: "linear-gradient-147",
    x1: 813.21,
    x2: 835.75,
    y1: 515.45,
    y2: 537.99
  })), _linearGradient148 || (_linearGradient148 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-98",
    id: "linear-gradient-148",
    x1: 767.15,
    x2: 786.53,
    y1: 515.28,
    y2: 534.66
  })), _linearGradient149 || (_linearGradient149 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-98",
    id: "linear-gradient-149",
    x1: 914.56,
    x2: 926.28,
    y1: 571.18,
    y2: 571.18
  })), _linearGradient150 || (_linearGradient150 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-98",
    id: "linear-gradient-150",
    x1: 910.74,
    x2: 931.16,
    y1: 396.81,
    y2: 633.82
  })), _linearGradient151 || (_linearGradient151 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-4",
    id: "linear-gradient-151",
    x1: -1503.8,
    x2: -1491.78,
    y1: 716.61,
    y2: 716.61,
    gradientTransform: "matrix(-1 0 0 1 -552.69 0)"
  })), _linearGradient152 || (_linearGradient152 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-98",
    id: "linear-gradient-152",
    x1: -1505.83,
    x2: -1488.61,
    y1: 673.23,
    y2: 673.23,
    gradientTransform: "matrix(-1 0 0 1 -552.69 0)"
  })), _linearGradient153 || (_linearGradient153 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-4",
    id: "linear-gradient-153",
    x1: 2840.09,
    x2: 2852.8,
    y1: 716.61,
    y2: 716.61,
    gradientTransform: "translate(-1881.31)"
  })), _linearGradient154 || (_linearGradient154 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-98",
    id: "linear-gradient-154",
    x1: 2838.75,
    x2: 2855.97,
    y1: 673.23,
    y2: 673.23,
    gradientTransform: "translate(-1881.31)"
  })), _linearGradient155 || (_linearGradient155 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-155",
    x1: 890.35,
    x2: 1057.9,
    y1: 644.74,
    y2: 463.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2c759e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#051042"
  }))), _linearGradient156 || (_linearGradient156 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-10",
    id: "linear-gradient-156",
    x1: 950.4,
    x2: 970.83,
    y1: 393.39,
    y2: 630.41
  })), _linearGradient157 || (_linearGradient157 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-98",
    id: "linear-gradient-157",
    x1: 983.46,
    x2: 1003.89,
    y1: 390.55,
    y2: 627.55
  })), _linearGradient158 || (_linearGradient158 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-98",
    id: "linear-gradient-158",
    x1: 969.26,
    x2: 984.31,
    y1: 529.4,
    y2: 529.4
  })), _linearGradient159 || (_linearGradient159 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-98",
    id: "linear-gradient-159",
    x1: 970.43,
    x2: 977.86,
    y1: 430.43,
    y2: 422.42
  })), _linearGradient160 || (_linearGradient160 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-98",
    id: "linear-gradient-160",
    x1: 932.26,
    x2: 957.26,
    y1: 462.62,
    y2: 400.28
  })), _linearGradient161 || (_linearGradient161 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-98",
    id: "linear-gradient-161",
    x1: 928.75,
    x2: 953.75,
    y1: 461.2,
    y2: 398.86
  })), _linearGradient162 || (_linearGradient162 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-162",
    x1: 928.8,
    x2: 966.23,
    y1: 405.18,
    y2: 356.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9b776"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#f9b475"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f47960"
  }))), _linearGradient163 || (_linearGradient163 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-7",
    id: "linear-gradient-163",
    x1: 958.98,
    x2: 984.82,
    y1: 376.69,
    y2: 350.85
  })), _linearGradient164 || (_linearGradient164 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-7",
    id: "linear-gradient-164",
    x1: 971.44,
    x2: 936.99,
    y1: 352.1,
    y2: 395.83
  })), _linearGradient165 || (_linearGradient165 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-98",
    id: "linear-gradient-165",
    x1: 939.81,
    x2: 977.33,
    y1: 414.13,
    y2: 365.63
  })), _linearGradient166 || (_linearGradient166 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-98",
    id: "linear-gradient-166",
    x1: 845.56,
    x2: 852.57,
    y1: 651.13,
    y2: 587.12
  })), _linearGradient167 || (_linearGradient167 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-98",
    id: "linear-gradient-167",
    x1: -1827.33,
    x2: -1820.85,
    y1: 484.98,
    y2: 425.82,
    gradientTransform: "matrix(-1 -.03 -.03 1 -962.23 114.14)"
  })), _linearGradient168 || (_linearGradient168 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-4",
    id: "linear-gradient-168",
    x1: 877.27,
    x2: 888.29,
    y1: 717.8,
    y2: 717.8
  })), _linearGradient169 || (_linearGradient169 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-98",
    id: "linear-gradient-169",
    x1: 871.1,
    x2: 887.45,
    y1: 682.39,
    y2: 682.39
  })), _linearGradient170 || (_linearGradient170 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-4",
    id: "linear-gradient-170",
    x1: -1416.15,
    x2: -1405.13,
    y1: 717.8,
    y2: 717.8,
    gradientTransform: "matrix(-1 0 0 1 -552.69 0)"
  })), _linearGradient171 || (_linearGradient171 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-98",
    id: "linear-gradient-171",
    x1: -1420.86,
    x2: -1405.97,
    y1: 682.39,
    y2: 682.39,
    gradientTransform: "matrix(-1 0 0 1 -552.69 0)"
  })), _linearGradient172 || (_linearGradient172 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-7",
    id: "linear-gradient-172",
    x1: 872.64,
    x2: 863.82,
    y1: 693.64,
    y2: 617.13
  })), _linearGradient173 || (_linearGradient173 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-10",
    id: "linear-gradient-173",
    x1: 883.19,
    x2: 826.36,
    y1: 581.12,
    y2: 677.41
  })), _linearGradient174 || (_linearGradient174 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-7",
    id: "linear-gradient-174",
    x1: 764.62,
    x2: 793.79,
    y1: 189.27,
    y2: 156.61,
    gradientTransform: "rotate(26.72 22.323 549.487)"
  })), _linearGradient175 || (_linearGradient175 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-98",
    id: "linear-gradient-175",
    x1: 866.3,
    x2: 867.89,
    y1: 599.39,
    y2: 583.19
  })), _linearGradient176 || (_linearGradient176 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-98",
    id: "linear-gradient-176",
    x1: 264.63,
    x2: 266.75,
    y1: 372.18,
    y2: 340.58,
    gradientTransform: "rotate(20.08 -29.755 2186.598)"
  })), _linearGradient177 || (_linearGradient177 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-98",
    id: "linear-gradient-177",
    x1: 777.64,
    x2: 779.57,
    y1: 196.83,
    y2: 168.15,
    gradientTransform: "rotate(26.72 22.323 549.487)"
  })), _linearGradient178 || (_linearGradient178 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-7",
    id: "linear-gradient-178",
    x1: 762.83,
    x2: 791.99,
    y1: 187.67,
    y2: 155,
    gradientTransform: "rotate(26.72 22.323 549.487)"
  })), _linearGradient179 || (_linearGradient179 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-98",
    id: "linear-gradient-179",
    x1: 878.41,
    x2: 885.4,
    y1: 650.87,
    y2: 587.09
  })), _linearGradient180 || (_linearGradient180 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-98",
    id: "linear-gradient-180",
    x1: 276.6,
    x2: 283.09,
    y1: 718.46,
    y2: 659.3,
    gradientTransform: "rotate(-4.29 -328.062 -7448.587)"
  })), _linearGradient181 || (_linearGradient181 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-98",
    id: "linear-gradient-181",
    x1: 964.34,
    x2: 971.75,
    y1: 649.51,
    y2: 581.91
  })), _linearGradient182 || (_linearGradient182 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-98",
    id: "linear-gradient-182",
    x1: -1169.9,
    x2: -1163.42,
    y1: 647.96,
    y2: 588.8,
    gradientTransform: "matrix(-1 0 0 1 -198.59 0)"
  })), _linearGradient183 || (_linearGradient183 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-4",
    id: "linear-gradient-183",
    x1: -697.23,
    x2: -685.19,
    y1: 722.93,
    y2: 722.93,
    gradientTransform: "matrix(-1 0 0 1 287.07 0)"
  })), _linearGradient184 || (_linearGradient184 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-4",
    id: "linear-gradient-184",
    x1: 998.38,
    x2: 1010.41,
    y1: 722.93,
    y2: 722.93,
    gradientTransform: "translate(-6.51)"
  })), _linearGradient185 || (_linearGradient185 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-98",
    id: "linear-gradient-185",
    x1: 977.3,
    x2: 980.69,
    y1: 706.94,
    y2: 623.97
  })), _linearGradient186 || (_linearGradient186 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-98",
    id: "linear-gradient-186",
    x1: 996,
    x2: 999.4,
    y1: 707.7,
    y2: 624.73
  })), _linearGradient187 || (_linearGradient187 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-7",
    id: "linear-gradient-187",
    x1: 970.18,
    x2: 1006.58,
    y1: 644.9,
    y2: 644.9
  })), _linearGradient188 || (_linearGradient188 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-7",
    id: "linear-gradient-188",
    x1: -664.85,
    x2: -663.6,
    y1: 496.26,
    y2: 522.51,
    gradientTransform: "scale(-1 1) rotate(-8 -29.279 2959.297)"
  })), _linearGradient189 || (_linearGradient189 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-8",
    id: "linear-gradient-189",
    x1: 992.14,
    x2: 981.45,
    y1: 582.19,
    y2: 648.52
  })), _linearGradient190 || (_linearGradient190 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-98",
    id: "linear-gradient-190",
    x1: 988.32,
    x2: 989.99,
    y1: 596.23,
    y2: 556.47
  })), _linearGradient191 || (_linearGradient191 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-98",
    id: "linear-gradient-191",
    x1: 988.98,
    x2: 990.9,
    y1: 572.82,
    y2: 544.14
  })), _linearGradient192 || (_linearGradient192 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-7",
    id: "linear-gradient-192",
    x1: 999.28,
    x2: 967.46,
    y1: 558.46,
    y2: 497.67
  })), _linearGradient193 || (_linearGradient193 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-98",
    id: "linear-gradient-193",
    x1: 431.83,
    x2: 433.95,
    y1: 770.15,
    y2: 738.54,
    gradientTransform: "rotate(-7 -919.19 -4121.755)"
  })), _linearGradient194 || (_linearGradient194 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-98",
    id: "linear-gradient-194",
    x1: 987.65,
    x2: 989.28,
    y1: 594.53,
    y2: 555.82
  })), _linearGradient195 || (_linearGradient195 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-98",
    id: "linear-gradient-195",
    x1: 1003.47,
    x2: 1010.72,
    y1: 648.94,
    y2: 582.73
  })), _linearGradient196 || (_linearGradient196 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-98",
    id: "linear-gradient-196",
    x1: 401.74,
    x2: 408.47,
    y1: 725.89,
    y2: 664.48,
    gradientTransform: "rotate(-4.29 -328.062 -7448.587)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(-94.25 -69.15)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h1200v800H0z",
    style: {
      fill: "none"
    }
  })), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".cls-21,.cls-34,.cls-6{fill:#fff}.cls-6{opacity:.57}.cls-34{opacity:.37}.cls-85{opacity:.6}"))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M974 125a76.29 76.29 0 0 0-9.46-4.4c-38.34-14.65-73 1-111.09-21.83-35.94-21.49-70.05-33.58-112.05-28.43-59 7.23-111.91 48-150 94.8-68.68 84.34-80.61 174.18-271.11 40.78s-261.06 104.83-203.49 170 28.64 66.41-7.39 179.75 104.85 193.56 227.22 123 105.5-77.86 267.65-4.1 279.58-14.76 381.93-94.69c77.16-60.27 114.94-155.29 95.29-255.59-7.53-38.46-22-79.27-38.62-114.35-14.65-30.89-38.42-68.32-68.88-84.94Z",
    style: {
      opacity: 0.5,
      fill: "url(#linear-gradient)"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1082.23 245.68c-30.49-30.8-84.58-38.46-125.25-34-82 9.05-207.17 53.19-285.57 8.91-39-22.05-59-71.16-96.43-96.4-33.15-22.34-78.74-27.71-117.15-28.45-150-2.87-198.34 168.14-281.12 265.49-72.13 84.81-31.84 202.14 42.68 264.85 97.23 81.82 222.43 66.18 338.58 49.32 98-14.22 192.43 9.75 290 8.84 66.35-.63 144.87-20.06 104.54-106.9-51.95-111.84 144.35-160 152.8-261.75 2.58-30.85-6.95-53.59-23.08-69.91Z",
    style: {
      opacity: 0.3,
      fill: "url(#linear-gradient-2)"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.14 446.34c-13.21-49.64-41.39-90.07-75.86-114.72a145.75 145.75 0 0 1-59-92.28q-1.06-5.88-2.64-11.79c-15.89-59.7-65.36-98.35-110.48-86.34s-68.81 70.15-52.91 129.85a144.55 144.55 0 0 0 13.64 33.72c18.3 32.52 24.27 70.73 15.27 107-8 32.38-8 69.29 1.91 106.5 14.78 55.5 48.27 99.5 88.34 122.79a143.38 143.38 0 0 1 39.64 34c18.26 22.67 44.94 34.23 70.27 27.48 27.33-7.28 45.43-33.81 48.14-65.68a153.17 153.17 0 0 1 14.28-51.93c18.18-38.8 22.77-88.42 9.4-138.6Z",
    style: {
      fill: "url(#linear-gradient-3)"
    },
    transform: "translate(-94.25 -69.15)"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M234.66 131.36c16.4 37.88 31.57 76.26 46.34 114.8 3.7 9.64 7.24 19.33 10.81 29l5.36 14.52 5.23 14.56c3.45 9.72 7 19.4 10.38 29.16l10 29.29c6.44 19.61 13 39.17 19.11 58.89 3.05 9.86 6.29 19.66 9.14 29.59l8.72 29.73c11.18 39.74 21.36 79.78 29.5 120.26l-1.74.36-7.24-30-1.8-7.51-2-7.47-4-14.93-4-14.94c-1.31-5-2.81-9.91-4.2-14.87-2.86-9.9-5.63-19.82-8.55-29.7-11.94-39.45-24.4-78.73-37.67-117.76-6.78-19.46-13.4-39-20.31-58.4l-5.15-14.57-5.27-14.54c-3.51-9.69-7-19.38-10.63-29q-10.58-29.06-21.58-58c-7.24-19.3-14.67-38.54-22.15-57.75Z",
    className: "cls-6"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M339.48 432.56c-16.88-32-42.54-55.31-70-66.83a102.76 102.76 0 0 1-54.92-54.09q-1.65-3.86-3.66-7.67c-20.3-38.47-60.26-57.25-89.26-41.94s-36.06 58.88-15.77 97.35a102.54 102.54 0 0 0 14.65 21c17.66 19.44 27.77 44.73 27.32 71-.4 23.47 5.45 48.78 18.1 72.76 18.87 35.77 48.73 60.71 79.84 70.42a100.85 100.85 0 0 1 32.5 17.1c16.07 12.69 36.17 16.44 52.45 7.85 17.56-9.26 25.78-30.3 22.61-52.58a107.61 107.61 0 0 1 1.59-37.86c6.29-29.41 1.61-64.17-15.45-96.51Z",
    style: {
      fill: "url(#linear-gradient-4)"
    },
    transform: "translate(-94.25 -69.15)"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1 228.44c17.2 23.41 33.65 47.41 49.83 71.51 4 6 8 12.12 12 18.2l6 9.12 5.82 9.18c3.89 6.13 7.87 12.21 11.7 18.38l11.48 18.52c7.5 12.45 15.11 24.83 22.37 37.42 3.64 6.28 7.41 12.5 10.92 18.86l10.63 19c13.92 25.51 27.2 51.39 39.16 77.89l-1.14.52-9.69-19.48-2.43-4.85-2.53-4.81-5.09-9.62-5.06-9.63c-1.68-3.21-3.49-6.36-5.22-9.54-3.52-6.35-7-12.72-10.54-19q-21.56-37.83-44.35-74.93c-7.71-12.29-15.32-24.65-23.12-36.89l-5.82-9.19-5.9-9.14c-3.93-6.1-7.86-12.2-11.85-18.26q-11.82-18.28-23.91-36.39t-24.28-36.15Z",
    className: "cls-6"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M873.25 488.35c15.75-32.56 19.31-67.06 12.29-96a102.79 102.79 0 0 1 11-76.29q2.13-3.63 4-7.5c18.94-39.15 10.37-82.47-19.15-96.75s-68.8 5.88-87.74 45a101.41 101.41 0 0 0-8.22 24.25c-5.19 25.75-19.56 48.88-41 64.09-19.14 13.59-36.06 33.31-47.87 57.71-17.61 36.4-20 75.24-9.36 106a101 101 0 0 1 5.5 36.31c-.69 20.47 8.2 38.88 24.77 46.9 17.88 8.65 39.69 2.79 55.75-13A107.93 107.93 0 0 1 804.68 558c27.42-12.37 52.64-36.74 68.57-69.65Z",
    style: {
      fill: "url(#linear-gradient-5)"
    },
    transform: "translate(-94.25 -69.15)"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M777.33 189.29c-8.67 27.74-18.21 55.18-28 82.52-2.46 6.83-5 13.63-7.56 20.43l-3.82 10.21-3.9 10.17c-2.63 6.78-5.16 13.59-7.86 20.33l-8.11 20.23c-5.58 13.42-11 26.88-16.87 40.19-2.9 6.66-5.67 13.38-8.71 20l-9 19.84c-12.3 26.34-25.26 52.38-39.51 77.71l-1.09-.6 9.85-19.38 2.49-4.83 2.38-4.9 4.73-9.8 4.75-9.78c1.59-3.26 3-6.58 4.59-9.87 3-6.59 6.1-13.16 9.08-19.77 11.75-26.52 23.16-53.21 34-80.12 5.33-13.5 10.77-26.95 16-40.48l4-10.14 3.86-10.18c2.58-6.78 5.17-13.56 7.68-20.36q7.71-20.37 15.12-40.83t14.72-41Z",
    className: "cls-6"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M192.75 521.85h526v46h-526z",
    style: {
      fill: "url(#linear-gradient-6)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M715.75 521.85h15v58h-15z",
    style: {
      fill: "url(#linear-gradient-7)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295 312.94c0-11.53 10.61-20.94 23.82-20.94h497.49c13.21 0 24.69 9.41 24.69 20.94v262.19c0 11.52-11.48 20.87-24.69 20.87H318.82c-13.21 0-23.82-9.35-23.82-20.87Z",
    style: {
      fill: "url(#linear-gradient-8)"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311 323.51C311 313 319.94 305 332.39 305h469.32c12.46 0 23.29 8 23.29 18.51v239.66c0 10.54-10.83 19.83-23.29 19.83H332.39c-12.45 0-21.39-9.29-21.39-19.83Z",
    style: {
      fill: "url(#linear-gradient-9)",
      opacity: 0.7
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m120.64 503.44 32.68-101.1a6.23 6.23 0 0 1 5.84-4.34H290v239H112.9Z",
    style: {
      fill: "url(#linear-gradient-10)"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.6 601.46a11.53 11.53 0 0 1 6.51-1.74l137 2.64.64 38.9-137.08 3.36c-5 0-9.65-2.42-9.65-5.81v-32.95a5.22 5.22 0 0 1 2.58-4.4Z",
    style: {
      fill: "url(#linear-gradient-11)"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m146.15 497 19.75-77.68a5.85 5.85 0 0 1 5.95-4.29h77.26a5.83 5.83 0 0 1 4.4 1.52 5.74 5.74 0 0 1 1.74 4.28l-1.86 62.57a6.09 6.09 0 0 1-5.15 5.84l-95.16 15.35a6.15 6.15 0 0 1-6.93-7.59Z",
    style: {
      fill: "url(#linear-gradient-12)"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m150.1 413 1 .17a6.14 6.14 0 0 1 4.92 7.65l-21.52 80.11a6.15 6.15 0 0 1-7.06 4.44l-6.8-1.28Z",
    style: {
      fill: "url(#linear-gradient-13)"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 13,
    x: 127.75,
    y: 438.85,
    rx: 5.8,
    style: {
      fill: "url(#linear-gradient-14)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.38 328a8.38 8.38 0 0 1 5.92 2.18 8.27 8.27 0 0 1 2.7 5.66V398h-79.58s4.3-65.12 70.96-70Z",
    style: {
      fill: "url(#linear-gradient-15)"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 114.14,
    cy: 572.98,
    r: 62.25,
    style: {
      fill: "url(#linear-gradient-16)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 208.4,
    cy: 642.13,
    r: 50.56,
    style: {
      fill: "url(#linear-gradient-17)"
    },
    transform: "rotate(-87.39 125.089 656.884)"
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M71.68 592.14a1.63 1.63 0 0 0 .68-.14 1.73 1.73 0 0 0 .92-2.27 43 43 0 0 1 60.65-54.31 1.74 1.74 0 0 0 1.7-3 46.53 46.53 0 0 0-65.55 58.69 1.75 1.75 0 0 0 1.6 1.03Z",
    className: "cls-21"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 208.4,
    cy: 642.36,
    r: 23.19,
    style: {
      fill: "url(#linear-gradient-18)"
    },
    transform: "rotate(-13.15 -138.716 1016.621)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 497.95,
    cy: 572.98,
    r: 62.25,
    style: {
      fill: "url(#linear-gradient-19)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 592.21,
    cy: 642.13,
    r: 50.56,
    style: {
      fill: "url(#linear-gradient-20)"
    },
    transform: "rotate(-86.41 508.326 657.737)"
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M455.49 592.14a1.63 1.63 0 0 0 .68-.14 1.73 1.73 0 0 0 .92-2.27 43 43 0 0 1 60.66-54.31 1.73 1.73 0 1 0 1.69-3 46.52 46.52 0 0 0-65.54 58.69 1.75 1.75 0 0 0 1.59 1.03Z",
    className: "cls-21"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 592.21,
    cy: 642.36,
    r: 23.19,
    style: {
      fill: "url(#linear-gradient-21)"
    },
    transform: "rotate(-6.98 -21.898 1380.462)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 640.36,
    cy: 572.98,
    r: 62.25,
    style: {
      fill: "url(#linear-gradient-22)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 734.62,
    cy: 642.13,
    r: 50.56,
    style: {
      fill: "url(#linear-gradient-23)"
    },
    transform: "rotate(-87.13 651.138 657.11)"
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M597.9 592.14a1.63 1.63 0 0 0 .68-.14 1.73 1.73 0 0 0 .92-2.27 43 43 0 0 1 60.65-54.31 1.73 1.73 0 1 0 1.69-3 46.52 46.52 0 0 0-65.54 58.69 1.75 1.75 0 0 0 1.6 1.03Z",
    className: "cls-21"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 734.62,
    cy: 642.36,
    r: 23.19,
    style: {
      fill: "url(#linear-gradient-24)"
    },
    transform: "rotate(-13.15 387.519 1016.661)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 33,
    x: 17.75,
    y: 494.85,
    rx: 6.15,
    style: {
      fill: "url(#linear-gradient-25)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129 564v32h4.07c3.39 0 6.93-3.34 6.93-6.73v-20.21c0-3.39-3.54-5.06-6.93-5.06Z",
    style: {
      opacity: 0.8,
      fill: "#fff"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381 634.61v.56c0 .17-.93 1.08-.91 1.23.24 15.43 11.91 28.6 27.41 28.6H470c15.5 0 28.43-13.17 28.68-28.6 0-.15.35-1.06.35-1.23v-.56a26.06 26.06 0 0 0-1.54-7.86C493.93 615.11 482.77 607 470 607h-62.5c-12.8 0-22.69 8.11-26.22 19.75-.79 2.6-.28 5-.28 7.86Z",
    style: {
      fill: "url(#linear-gradient-26)"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381 634.61v.56a9.27 9.27 0 0 1-1.84.83h119.15s.69-.66.69-.83v-.56c0-2.86-1.09-4.61-1.88-6.61H380.35c-.79 2 .65 3.75.65 6.61Z",
    style: {
      opacity: 0.7,
      fill: "#fff"
    },
    transform: "translate(-94.25 -69.15)"
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 64,
    x: 368.75,
    y: 521.85,
    className: "cls-21",
    rx: 1.84
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 64,
    x: 313.75,
    y: 521.85,
    className: "cls-21",
    rx: 1.84
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M184.75 488.85a2 2 0 0 0 2-1.74V344.73a2 2 0 0 0-4 0v142.41a2 2 0 0 0 2 1.71ZM130.87 324.07a1.75 1.75 0 0 0 1.65-1.17c18.23-52.88 54.66-49.33 56.23-49.15a1.74 1.74 0 0 0 .41-3.45c-.42 0-40.7-4.16-59.9 51.47a1.73 1.73 0 0 0 1.08 2.2 1.58 1.58 0 0 0 .53.1Z",
    className: "cls-21"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M304.27 705.66v-73.14A17.54 17.54 0 0 1 321.6 615c28.84-.31 88.33-.33 137 3.77a13.18 13.18 0 0 1 12.05 12.67l4.55 70.71a16.74 16.74 0 0 1-16.41 17.35L321 722.1a16.44 16.44 0 0 1-16.73-16.44Z",
    style: {
      fill: "url(#linear-gradient-27)"
    },
    transform: "translate(-94.25 -69.15)"
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M226.75 571.28c-.13 6.22.06 16.1.21 22.48a5.63 5.63 0 0 0 6.29 5.46l23.73-2.78a5.63 5.63 0 0 0 4.92-6.43l-2.91-19.44a5.63 5.63 0 0 0-5.57-4.8h-21a5.63 5.63 0 0 0-5.67 5.51Z",
    className: "cls-21"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m288.75 608.11 19.8 2.14a4.46 4.46 0 0 0 4.93-4.77l-4.33-58.89c-8.3-.27-16.48-.46-24.38-.59v57.67a4.46 4.46 0 0 0 3.98 4.44Z",
    className: "cls-34"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M296.87 597.9a2 2 0 0 0 2 1.88h.12a2 2 0 0 0 1.87-2.11l-3-51.4-4-.09Z",
    className: "cls-21"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M332 659a.67.67 0 0 1-.66-.62l-1-16.19a.66.66 0 0 1 .62-.7.65.65 0 0 1 .71.62l1 16.19a.67.67 0 0 1-.63.7Z",
    style: {
      fill: "url(#linear-gradient-28)"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.07 659a.66.66 0 0 1-.67-.64l-.54-16.5a.66.66 0 0 1 .65-.68.62.62 0 0 1 .68.64l.54 16.5a.67.67 0 0 1-.64.68Z",
    style: {
      fill: "url(#linear-gradient-29)"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.9 659a.65.65 0 0 1-.66-.63c-.13-2.71-.78-16.26-.78-16.53a.67.67 0 0 1 1.33 0c0 .36.51 10.94.77 16.48a.66.66 0 0 1-.63.69Zm-.11-17.16Z",
    style: {
      fill: "url(#linear-gradient-30)"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.33 659.65a1.33 1.33 0 0 1-1.33-1.28c-.56-16-.46-16.35-.4-16.59a1.33 1.33 0 0 1 2.6.53c0 1 .25 10.26.45 16a1.33 1.33 0 0 1-1.28 1.38Z",
    style: {
      fill: "url(#linear-gradient-31)"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.2 659a.66.66 0 0 1-.66-.66v-16.21a.67.67 0 0 1 1.33 0v16.19a.66.66 0 0 1-.67.68Z",
    style: {
      fill: "url(#linear-gradient-32)"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.53 659a.67.67 0 0 1-.67-.65c-.12-5.62-.42-14.81-.69-15.91a.68.68 0 0 1 0-.69.66.66 0 0 1 .92-.19c.36.23.7.46 1.07 16.76a.66.66 0 0 1-.65.68Z",
    style: {
      fill: "url(#linear-gradient-33)"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.38 660.46a1.32 1.32 0 0 1-1.32-1.26l-.89-17a1.33 1.33 0 1 1 2.65-.14l.89 17a1.34 1.34 0 0 1-1.26 1.4Z",
    style: {
      fill: "url(#linear-gradient-34)"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.39 605.48v-51.36a12.32 12.32 0 0 1 12.18-12.32c20.25-.22 62-.23 96.2 2.65a9.27 9.27 0 0 1 8.46 8.9l3.2 49.66a11.77 11.77 0 0 1-11.53 12.18L339.16 617a11.55 11.55 0 0 1-11.77-11.52Z",
    style: {
      fill: "url(#linear-gradient-35)"
    },
    transform: "translate(-94.25 -69.15)"
  }), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M244.88 490.52c-.09 4.38 0 11.31.15 15.79a4 4 0 0 0 4.41 3.84l16.67-2a3.94 3.94 0 0 0 3.45-4.51l-2-13.65a4 4 0 0 0-3.92-3.37h-14.81a3.94 3.94 0 0 0-3.95 3.9Z",
    className: "cls-21"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m288.43 516.39 13.91 1.5a3.14 3.14 0 0 0 3.46-3.35l-3-41.36c-5.83-.18-11.58-.32-17.12-.41v40.5a3.12 3.12 0 0 0 2.75 3.12Z",
    className: "cls-34"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M294.13 509.22a1.4 1.4 0 0 0 1.4 1.32h.08a1.4 1.4 0 0 0 1.31-1.48l-2.09-36.1-2.81-.06Z",
    className: "cls-21"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M346.83 572.7a.46.46 0 0 1-.46-.43l-.72-11.37a.47.47 0 0 1 .43-.5.46.46 0 0 1 .5.44l.72 11.37a.46.46 0 0 1-.44.49Z",
    style: {
      fill: "url(#linear-gradient-36)"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.32 572.7a.47.47 0 0 1-.47-.45l-.38-11.58a.48.48 0 0 1 .45-.49.45.45 0 0 1 .49.45l.37 11.59a.46.46 0 0 1-.45.48Z",
    style: {
      fill: "url(#linear-gradient-37)"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.31 572.7a.46.46 0 0 1-.47-.44c-.09-1.91-.54-11.42-.54-11.61a.47.47 0 1 1 .93 0c0 .25.36 7.67.54 11.57a.45.45 0 0 1-.44.48Zm-.08-12.05Z",
    style: {
      fill: "url(#linear-gradient-38)"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.42 573.17a.93.93 0 0 1-.93-.9c-.4-11.23-.33-11.48-.28-11.65a.93.93 0 0 1 1.79.38c0 .68.18 7.21.32 11.22a.94.94 0 0 1-.9 1Z",
    style: {
      fill: "url(#linear-gradient-39)"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.44 572.7a.46.46 0 0 1-.47-.46v-11.37a.47.47 0 1 1 .93 0v11.37a.46.46 0 0 1-.46.46Z",
    style: {
      fill: "url(#linear-gradient-40)"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.07 572.7a.47.47 0 0 1-.47-.45c-.09-4-.3-10.4-.48-11.18a.48.48 0 0 1 0-.48.47.47 0 0 1 .65-.14c.25.17.5.33.75 11.78a.45.45 0 0 1-.45.47Z",
    style: {
      fill: "url(#linear-gradient-41)"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.33 573.74a.94.94 0 0 1-.94-.88l-.62-11.94a.93.93 0 0 1 .89-1 1 1 0 0 1 1 .88l.62 11.94a.94.94 0 0 1-.89 1Z",
    style: {
      fill: "url(#linear-gradient-42)"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.7 704.73v-73.14a17.54 17.54 0 0 1 17.3-17.54c28.84-.31 88.32-.32 137 3.78a13.17 13.17 0 0 1 12.05 12.66l4.55 70.71a16.74 16.74 0 0 1-16.41 17.35l-137.76 2.62a16.45 16.45 0 0 1-16.73-16.44Z",
    style: {
      fill: "url(#linear-gradient-43)"
    },
    transform: "translate(-94.25 -69.15)"
  }), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M411.16 570.35c-.13 6.23.06 16.1.21 22.48a5.63 5.63 0 0 0 6.29 5.46l23.74-2.78a5.63 5.63 0 0 0 4.91-6.43l-2.91-19.44a5.63 5.63 0 0 0-5.57-4.8h-21.08a5.63 5.63 0 0 0-5.59 5.51Z",
    className: "cls-21"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m473.18 607.18 19.8 2.14a4.46 4.46 0 0 0 4.93-4.77l-4.33-58.89c-8.3-.26-16.48-.46-24.38-.59v57.68a4.45 4.45 0 0 0 3.98 4.43Z",
    className: "cls-34"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M481.3 596.98a2 2 0 0 0 2 1.87h.12a2 2 0 0 0 1.87-2.1l-3-51.41-4-.09Z",
    className: "cls-21"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M516.38 658.06a.67.67 0 0 1-.66-.63l-1-16.19a.67.67 0 0 1 .63-.7.64.64 0 0 1 .7.62l1 16.19a.66.66 0 0 1-.62.7Z",
    style: {
      fill: "url(#linear-gradient-44)"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.5 658.06a.67.67 0 0 1-.67-.65l-.53-16.5a.65.65 0 0 1 .64-.68.62.62 0 0 1 .68.64l.54 16.5a.68.68 0 0 1-.64.69Z",
    style: {
      fill: "url(#linear-gradient-45)"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.33 658.06a.67.67 0 0 1-.66-.64c-.13-2.71-.78-16.26-.78-16.53a.67.67 0 0 1 1.33 0c0 .37.51 10.94.77 16.48a.65.65 0 0 1-.63.69Zm-.11-17.17Z",
    style: {
      fill: "url(#linear-gradient-46)"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.76 658.72a1.33 1.33 0 0 1-1.33-1.28c-.56-16-.46-16.35-.4-16.59a1.33 1.33 0 0 1 2.6.53c0 1 .25 10.26.45 16a1.32 1.32 0 0 1-1.28 1.38Z",
    style: {
      fill: "url(#linear-gradient-47)"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.63 658.06a.67.67 0 0 1-.66-.67V641.2a.67.67 0 0 1 1.33 0v16.19a.67.67 0 0 1-.67.67Z",
    style: {
      fill: "url(#linear-gradient-48)"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531 658.06a.67.67 0 0 1-.67-.65c-.12-5.63-.42-14.82-.69-15.92a.68.68 0 0 1 0-.69.66.66 0 0 1 .92-.19c.36.24.7.46 1.07 16.77a.67.67 0 0 1-.65.68Z",
    style: {
      fill: "url(#linear-gradient-49)"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.81 659.53a1.32 1.32 0 0 1-1.32-1.26l-.89-17a1.34 1.34 0 0 1 1.26-1.4 1.35 1.35 0 0 1 1.39 1.26l.89 17a1.33 1.33 0 0 1-1.26 1.4Z",
    style: {
      fill: "url(#linear-gradient-50)"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.83 604.56v-51.37A12.3 12.3 0 0 1 524 540.88c20.25-.22 62-.24 96.2 2.64a9.26 9.26 0 0 1 8.46 8.9l3.2 49.66a11.76 11.76 0 0 1-11.53 12.18l-96.74 1.84a11.54 11.54 0 0 1-11.76-11.54Z",
    style: {
      fill: "url(#linear-gradient-51)"
    },
    transform: "translate(-94.25 -69.15)"
  }), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M429.31 489.6c-.09 4.37 0 11.3.15 15.78a4 4 0 0 0 4.41 3.84l16.67-2a4 4 0 0 0 3.46-4.52l-2-13.65a4 4 0 0 0-3.92-3.37h-14.82a4 4 0 0 0-3.95 3.92Z",
    className: "cls-21"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m472.87 515.46 13.9 1.5a3.13 3.13 0 0 0 3.46-3.34l-3-41.36c-5.83-.19-11.58-.32-17.12-.42v40.51a3.12 3.12 0 0 0 2.76 3.11Z",
    className: "cls-34"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M478.56 508.29a1.4 1.4 0 0 0 1.4 1.32h.08a1.41 1.41 0 0 0 1.32-1.48l-2.1-36.1-2.81-.06Z",
    className: "cls-21"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M531.26 571.78a.46.46 0 0 1-.46-.44l-.72-11.34a.47.47 0 0 1 .93-.06l.72 11.37a.47.47 0 0 1-.44.5Z",
    style: {
      fill: "url(#linear-gradient-52)"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.75 571.78a.47.47 0 0 1-.47-.45l-.38-11.59a.47.47 0 0 1 .46-.48.44.44 0 0 1 .48.45l.37 11.58a.47.47 0 0 1-.45.49Z",
    style: {
      fill: "url(#linear-gradient-53)"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.74 571.78a.48.48 0 0 1-.47-.45c-.09-1.9-.54-11.42-.54-11.61a.47.47 0 0 1 .93 0c0 .25.36 7.68.54 11.57a.46.46 0 0 1-.44.49Zm-.08-12.06Z",
    style: {
      fill: "url(#linear-gradient-54)"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.85 572.24a.92.92 0 0 1-.93-.9c-.4-11.22-.33-11.48-.28-11.64a.93.93 0 0 1 1.14-.66.94.94 0 0 1 .68 1c0 .68.18 7.21.32 11.22a.94.94 0 0 1-.9 1Z",
    style: {
      fill: "url(#linear-gradient-55)"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.87 571.78a.47.47 0 0 1-.47-.47v-11.37a.47.47 0 1 1 .93 0v11.37a.47.47 0 0 1-.46.47Z",
    style: {
      fill: "url(#linear-gradient-56)"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.5 571.78a.48.48 0 0 1-.47-.46c-.09-4-.3-10.4-.48-11.18a.47.47 0 0 1 .66-.62c.26.17.5.33.76 11.78a.48.48 0 0 1-.46.48Z",
    style: {
      fill: "url(#linear-gradient-57)"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.76 572.81a.92.92 0 0 1-.93-.88L527.2 560a.94.94 0 0 1 .89-1 1 1 0 0 1 1 .88l.62 11.94a.94.94 0 0 1-.88 1Z",
    style: {
      fill: "url(#linear-gradient-58)"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.81 199.71c-3.11-13.44-10.83-8.83-23.75-13s-9.15-18.89-17.17-23.44c-10.7-6.07-20.52-.44-27.17 7.53-11.06 13.24-18.62 2.47-31.83 7.84-7.58 3.07-4.35 7.37-14.59 9.11-7.15 1.21-14.9-1.64-21.95.1-5.22 1.29-9 3.56-10.17 8.17 1.48.64 3 1.21 4.58 1.73 19.74 6.5 46.68 4.33 66.63 5.29 6.81.35 77.61 6.2 75.42-3.33Z",
    style: {
      fill: "url(#linear-gradient-59)"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.34 150.62a13.74 13.74 0 0 0-13.41-4.21c-5.41 1.24-8.46 6-13.49 7.84-8.78 3.29-20.92-3.21-27.58 5.27-8.15 10.38-14.45 2.6-14.45 9.64s56.32 1.85 84.11 2.22c4 .05 21.45-.21 14-7.82-2.33-2.37-5.66-2.76-8.76-3.31-4-.73-13.65-1.12-16.57-4-1.58-1.55-2.19-3.77-3.61-5.42-.11-.07-.18-.14-.24-.21Z",
    style: {
      fill: "url(#linear-gradient-60)"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m847.84 133.34-63.08-55.07 1.32-1.51 61.71 53.88 58.72-55.34 1.37 1.45-60.04 56.59z",
    style: {
      fill: "url(#linear-gradient-61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m848.47 152.69-2-.04.35-20.68-.35-57.4 2-.01.35 57.42-.35 20.71z",
    style: {
      fill: "url(#linear-gradient-62)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m847.82 135.29-30.9-56.6 1.75-.95 29.15 53.38 29.2-53.39 1.75.96-30.95 56.6z",
    style: {
      fill: "url(#linear-gradient-63)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m886.72 177.94-39.04-24.82-38.53 23.52-1.04-1.71 39.59-24.17 40.09 25.49-1.07 1.69z",
    style: {
      fill: "url(#linear-gradient-64)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M986.77 287.16a8.8 8.8 0 0 1-8.63 9.11l-72.35 1.38A8.62 8.62 0 0 1 897 289v-38.41a9.18 9.18 0 0 1 5.68-8.5l.21-.08a8.68 8.68 0 0 1 3.21-.31c.48 0 1 .3 1.49.3h8.09c13.24 0 31.7-.18 49.27.8 1.68.09 3.36 0 5 .09l1.58.13a4.52 4.52 0 0 0 .52 0 12.48 12.48 0 0 1 6 1h.06a6.4 6.4 0 0 1 6.27 6.33Z",
    style: {
      fill: "url(#linear-gradient-65)"
    },
    transform: "translate(-94.25 -69.15)"
  }), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M823.5 201.1a2.26 2.26 0 0 1-2.59 2.38l-10.23-1.18a2.27 2.27 0 0 1-1.93-2.39v-27.06a8.38 8.38 0 0 1 3.15-.31c.48 0 .93.3 1.44.3h8.09Z",
    className: "cls-34"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M816.86 196.99a1 1 0 0 1-1 1s0-.06-.06-.06c-.56 0-1-.14-1-.69l-1.46-24.39h2.1Z",
    className: "cls-21"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M885.75 201a2.3 2.3 0 0 1-2.59 2.43l-10.38-1.16a2.35 2.35 0 0 1-2.07-2.36v-26.56c2 .1 3.33.14 5 .25.71.05 1.38.25 2.08.25a12.48 12.48 0 0 1 6 1h.06Z",
    className: "cls-34"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M879.15 196.76a1 1 0 0 1-1 1.1 1.05 1.05 0 0 1-1.05-1l-1.35-23.26c.7.05 1.4.25 2.1.25Z",
    className: "cls-21"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 36,
    x: 840.75,
    y: 182.85,
    rx: 0.87,
    style: {
      fill: "url(#linear-gradient-66)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 12,
    x: 829.75,
    y: 194.85,
    rx: 0.87,
    style: {
      fill: "url(#linear-gradient-67)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1002.44 146.66-15.53-8-15.18 9.92-15.08-11.22-14.58 11.22-14-10.7-15.93 10.44-15.42-9.66-18.16 9.57c3.4-13.75 16.38-46.08 63.2-46.08 45.13-.04 57.4 30.03 60.68 44.51Z",
    style: {
      fill: "url(#linear-gradient-68)"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M896.69 138.62s11.26-35.12 43.8-36.51c0 0-30.53 18.78-28.38 46.17-4.49-4.49-15.42-9.66-15.42-9.66Z",
    style: {
      fill: "url(#linear-gradient-69)"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m942.07 148.54-.34-46.43s-15.38 20.52-13.73 35.73c8 7.98 14.07 10.7 14.07 10.7Z",
    style: {
      fill: "url(#linear-gradient-70)"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M941.73 102.11s14.71 19 14.92 35.21l15.08 11.22s6.35-30.61-30-46.43Z",
    style: {
      fill: "url(#linear-gradient-71)"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M942.77 102.28s40.11 12.87 44.14 36.34l15.53 8s-6.28-43.62-59.67-44.34Z",
    style: {
      fill: "url(#linear-gradient-72)"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M902.75 321.73v304.12h-158V449.9l34.87-26.35 4.13-3.13v-21.27l10.07-9.76 9.02-8.78 59.21-58.17 40.7-.71z",
    style: {
      fill: "url(#linear-gradient-73)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M756.75 449.85h133v9h-133zM889.75 414.85v9H779.84l3.91-3.43v-5.57h106zM889.75 380.85v9h-95.8l8.95-9h86.85zM756.75 556.85h133v9h-133zM756.75 521.85h133v9h-133zM756.75 591.85h133v9h-133zM756.75 487.85h133v8h-133z",
    className: "cls-21"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M869.53 450.85h85.88l17.56 62.65 18.71-19.48 4.07 18.58v114.25h-139V506.52l14.68-.36-1.61-24.84-.29-30.47z",
    style: {
      fill: "url(#linear-gradient-74)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M906.75 426.85h6v28h-6z",
    style: {
      fill: "url(#linear-gradient-75)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M942.75 431.85h6v28h-6z",
    style: {
      fill: "url(#linear-gradient-76)"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-85"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M871.75 572.85h17v31h-17zM902.75 572.85h17v31h-17zM933.75 572.85h18v31h-18zM964.75 572.85h18v31h-18z",
    className: "cls-21"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-85"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M871.75 531.85h17v30h-17zM902.75 531.85h17v30h-17zM933.75 531.85h18v30h-18zM964.75 531.85h18v30h-18z",
    className: "cls-21"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "cls-85"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M871.75 486.85h17v30h-17zM902.75 486.85h17v30h-17zM933.75 486.85h18v30h-18z",
    className: "cls-21"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M310.32 705.27s-1.27 7.22-1.9 14.35a4.92 4.92 0 0 0 4.71 5.33c9.5.4 29.84 1.17 37.14.84a1.6 1.6 0 0 0 1.41-2.19 3.62 3.62 0 0 0-1.84-1.93l-33.59-15.44Z",
    style: {
      fill: "url(#linear-gradient-77)"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m309.28 701 1 8.62s5.88 2.74 9.9-.34l-2.43-9.62Z",
    style: {
      fill: "url(#linear-gradient-78)"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.05 538.86c-.45 2.25-2.38 112.42 9.4 161.78a1.68 1.68 0 0 1-1 2 29.09 29.09 0 0 1-9.59 1.95 2.89 2.89 0 0 1-2.87-2.07c-3.36-11.45-19.49-68.84-21.6-123.66-2.35-61.26 0-2.09 0-2.09l1.38-37.86Z",
    style: {
      fill: "url(#linear-gradient-79)"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.68 709s-2 3.64-4 13.31a3 3 0 0 0 2.64 3.6c3.14.3 8 .7 11.84.67a3 3 0 0 0 3-3.33c-.42-3.53-1.76-9.33-5.89-13.84Z",
    style: {
      fill: "url(#linear-gradient-80)"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m269.9 697.94 2.39 13s2.37 1.76 7 .48l-1.14-14Z",
    style: {
      fill: "url(#linear-gradient-81)"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.44 542.24c-9.63 58.12 2.09 143.66 6 160.4a2.61 2.61 0 0 0 2.11 2 17.58 17.58 0 0 0 7.53-.3 2.4 2.4 0 0 0 1.72-2.21c.53-13.53-.42-96.62 8.55-129.45a7.46 7.46 0 0 1 2.88-4.12l17.42-12.38 1.33-20Z",
    style: {
      fill: "url(#linear-gradient-82)"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.81 432.11c-28.87-.48-60.71 7.58-60.71 7.58-8.6 50.2-1.51 108.1-1.51 108.1 22.35 5.86 47.55-3.58 47.55-3.58 3.72-21 21-80 21-80A95.05 95.05 0 0 0 366.47 453c-7.3-8.46-10.74-19.23-12.23-25.59-10.24 3.15-20.53 4.85-29.43 4.7Z",
    style: {
      fill: "url(#linear-gradient-83)"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.06 389.6a5.53 5.53 0 0 0-6.43-1.81c-4.24 17.95-26.51 32.49-49.39 39.6 1.49 6.36 4.93 17.13 12.23 25.59 37.97-21.35 43.59-63.38 43.59-63.38Z",
    style: {
      fill: "url(#linear-gradient-84)"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.37 390.47c.3.94-3.14 2.38-5.16-1.48-.07-1.85-1.2-9.77-.09-11.27 5.88-8 17.29-18.08 17.29-18.08a2.71 2.71 0 0 1 .34 3.77l-5.54 5.77c1.16 2.09 2.57 3.85 3.23 6.38a7.7 7.7 0 0 1-.77 5.71 66.68 66.68 0 0 1-3.55 5.81 7.67 7.67 0 0 1-5.75 3.39Z",
    style: {
      fill: "url(#linear-gradient-85)"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m413.79 372.92-5 4.27-1.58 4.26 4.49 5s1.52-8.45 2.64-10.28.5-2.72-.55-3.25Z",
    style: {
      fill: "url(#linear-gradient-86)"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m275.17 467.64-11.07-27.95s-27 18.32-31.39 41.54a63.9 63.9 0 0 1 23.43 6.28c2-10.96 19.03-19.87 19.03-19.87Z",
    style: {
      fill: "url(#linear-gradient-87)"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.73 493.93s-30.27 17.11-40.48 2.5a11.49 11.49 0 0 1-2.11-8.92 63.9 63.9 0 0 0-23.43-6.28 32 32 0 0 0 3.48 22c17.89 32.73 66.54-1.81 66.54-1.81Z",
    style: {
      fill: "url(#linear-gradient-88)"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m295.09 515.57 16.52-57.68a1.69 1.69 0 0 1 1.42-1.22c3-.35 11.67-1.33 21.68-2.17 12.06-1 26.07-1.85 34.44-1.15a1.69 1.69 0 0 1 1.38 2.43c-4.76 9.63-24.34 48.8-34.14 61.63a1.68 1.68 0 0 1-1.37.67l-38.32-.35a1.7 1.7 0 0 1-1.61-2.16Z",
    style: {
      fill: "url(#linear-gradient-89)"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m336.42 449.5 12-2a.86.86 0 0 1 1 1.12l-1.19 3.59a.84.84 0 0 1-.7.58L336 454.33a.87.87 0 0 1-1-1.05l.74-3.13a.84.84 0 0 1 .68-.65Z",
    style: {
      fill: "url(#linear-gradient-90)"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m327.46 459.64 1-5.14a1.19 1.19 0 0 1 1.05-1l24.19-2.46a1.19 1.19 0 0 1 1.27 1.46l-1.55 6.5a1.2 1.2 0 0 1-1.1.91l-23.64 1.19a1.19 1.19 0 0 1-1.22-1.46Z",
    style: {
      fill: "url(#linear-gradient-91)"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.08 501.64s-2.3-9.47-1.37-12.82 2.73-7.68 8.72-6.72a87.83 87.83 0 0 1 13.07 3.49s-.36 4.37-4.92 3l2.83 2.18s-.41 3.51-4.25 1.64l2.62 2.89a3.06 3.06 0 0 1-4.48 1c-2.83-1.85-4.19 6.47-12.22 5.34Z",
    style: {
      fill: "url(#linear-gradient-92)"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m295.57 408.68-9.18 26.56a1 1 0 0 0 .43 1.15c2.51 1.38 11.53 5.38 22.4-1.51a4.49 4.49 0 0 0 2.07-3.21l3-23Z",
    style: {
      fill: "url(#linear-gradient-93)"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.55 384.09s10.09 19 8.8 26.65-13.8 7.11-24.71.89l-7.64-20.5Z",
    style: {
      fill: "url(#linear-gradient-94)"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.12 401.56a.77.77 0 0 0 .34-1.14 20.7 20.7 0 0 1-2.8-6s-1.81-1.16 4.61-2.7 16-3.93 18-9.4-3.2-18.74-11.43-8.06a.78.78 0 0 1-1.24 0c-1.35-1.75-4.9-5.4-9.82-3.19-4.62 2.07-5.13 5.45-5.07 7.15a.78.78 0 0 1-.92.8c-2.33-.45-7.93-.83-10.54 4.91-2.15 4.72-.75 7.4.52 8.71a.78.78 0 0 1-.33 1.29c-1.53.47-3.51 1.77-3.31 5.36.27 5 5.82 4.52 7.4 4.3a.77.77 0 0 1 .69.24c1.36 1.5 7.46 7.87 14.06 8.63a.79.79 0 0 0 .83-1l-2.86-8.31a.78.78 0 0 1 .43-1Z",
    style: {
      fill: "url(#linear-gradient-95)"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.27 402.74s-7.18-4.93-7.7-.78 6.46 6 9.93 4.46Z",
    style: {
      fill: "url(#linear-gradient-96)"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.83 711.37s-2.88 4.55-3.61 17.29a2.07 2.07 0 0 0 2.06 2.2h22.58a1.33 1.33 0 0 0 1.27-1.75c-1.33-3.92-5.33-13.46-14.25-18.92Z",
    style: {
      fill: "url(#linear-gradient-97)"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m395.85 702.74 1.28 10.7a2 2 0 0 0 1.76 1.77 17.38 17.38 0 0 0 4.77 0 3.3 3.3 0 0 0 2.73-3.28v-10.38Z",
    style: {
      fill: "url(#linear-gradient-98)"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.7 710.19a31.57 31.57 0 0 0-4.23 15.94 4 4 0 0 0 4 3.9h35.07a1.68 1.68 0 0 0 1-3c-6.63-4.66-19.67-13.37-29.11-16.79Z",
    style: {
      fill: "url(#linear-gradient-99)"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m449.09 698.62 2.72 13.23A2.73 2.73 0 0 0 455 714a10 10 0 0 0 3.08-1.28 3.15 3.15 0 0 0 1.4-3.2l-2.82-16Z",
    style: {
      fill: "url(#linear-gradient-100)"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.86 514.75s-9.47 8.35-11.26 18.4 5 173.33 5 173.33 9.47 1.57 14.36-1.38c0 0 5.79-106 10.19-130.46 0 0 23.08 109.77 29.48 129.6 0 0 9.12 1.11 12.06-.62 0 0-6-142.3-13.64-167.6Z",
    style: {
      fill: "url(#linear-gradient-101)"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.92 570.91a.74.74 0 0 1-.72-.56l-3.95-15.15-8.45-5.41a.75.75 0 0 1 .81-1.27l8.69 5.58a.77.77 0 0 1 .33.44l4 15.43a.76.76 0 0 1-.54.92.62.62 0 0 1-.17.02Z",
    style: {
      fill: "#666694"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.32 420.4c-39.87-3.31-50.29 4.94-50.29 4.94l19.16 30.25s39.18-.77 67.25-22.41a68.62 68.62 0 0 1-11.24-16.78 52.82 52.82 0 0 1-24.88 4Z",
    style: {
      fill: "url(#linear-gradient-102)"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.76 361.88a1.22 1.22 0 0 0-2.33-.47l-5.09 10.85a11.38 11.38 0 0 0-.9 6.73l1.79 6.32A10.93 10.93 0 0 1 548 394c-4.67 5.85-14.63 16.52-28.8 22.41a68.62 68.62 0 0 0 11.24 16.78A68.72 68.72 0 0 0 554.37 400a5.35 5.35 0 0 0 3.77-5.31Z",
    style: {
      fill: "url(#linear-gradient-103)"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.45 437.94c-14-15.13-40.78-22-56.25-24.77a14.2 14.2 0 0 0-15.87 9c-7 18.72-25.91 67.44-29.59 75.81-3 6.87-6.16 13.58-8.15 17.77a5 5 0 0 0 2.35 6.71c13 6.28 36.45 13.38 45.95 16.15a3.26 3.26 0 0 0 4.17-3.13 10.17 10.17 0 0 1 1.46-5.24l36-60c22.42 24.86 42.06 27.14 57.15 21.7a112.91 112.91 0 0 1-5-23.57c-22.3-3.77-32.22-30.43-32.22-30.43Z",
    style: {
      fill: "url(#linear-gradient-104)"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m576.5 464.25-4-5.36c-13 8.94-23.9 11.06-32.81 9.53a112.91 112.91 0 0 0 5 23.57c19.83-7.17 31.81-27.74 31.81-27.74Z",
    style: {
      fill: "url(#linear-gradient-105)"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m573.66 464.35 22.66.88 20.86-11.65c-3-1.88-19.93 2-19.93 2s-17.7-2.68-22.49-2.69c-4 0-3.41 5.72-3.11 7.66.07.39.12.63.12.63Z",
    style: {
      fill: "url(#linear-gradient-106)"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m472.49 385.4-12 29.17s13.74 9.51 24.79 8.61l6-26.24Z",
    style: {
      fill: "url(#linear-gradient-107)"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.68 365.51c.28.38 8.65 30.64 8.65 30.64L484 400.57l-12.2-27.5s16.3-14.07 20.88-7.56Z",
    style: {
      fill: "url(#linear-gradient-108)"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m478.3 377.25 5.29 15a2.4 2.4 0 0 0 .27.53c.72 1 3.45 4.35 6.68 1.35 2.94-2.72 5.65-5.16 8.16-5.6a2.22 2.22 0 0 1 2.53 1.59 95.61 95.61 0 0 1 2.92 14.6 2.21 2.21 0 0 1-1.8 2.39c-3.39.64-10.59 1.8-16.6 1.38a2.24 2.24 0 0 1-1.87-1.29c-1.65-3.62-6.73-14.59-8.61-17.43-1.78-2.67-6.12-2.6-7.94-2.43a2.17 2.17 0 0 1-1.63-.54c-1.59-1.4-4.63-5-.36-9.23a2.23 2.23 0 0 0 0-3.2c-1.83-1.72-3.79-4.77-.74-8.56s7.19-3.24 9.7-2.32a2.21 2.21 0 0 0 2.67-1 1.74 1.74 0 0 1 1.81-.84 2.2 2.2 0 0 0 2.34-2.25c-.05-2.46.83-5.58 5.11-6.91 7.59-2.36 12.33 5 12.8 10.44s-7.91 7.57-12.84 7.2c-3.74-.28-6.52 3.43-7.64 5.23a2.23 2.23 0 0 0-.25 1.89Z",
    style: {
      fill: "url(#linear-gradient-109)"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.25 395.18s-1.23-9.5-5.18-10-7.8 2.79-3.87 8.12c4.89 6.7 9.05 1.88 9.05 1.88Z",
    style: {
      fill: "url(#linear-gradient-110)"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m552.38 348.54 48.24-16.65a12.24 12.24 0 0 1 15.51 7.44c6.76 18.95 20.31 58.18 28.68 91.21a9.18 9.18 0 0 1-5.61 10.82l-45.6 19.09a11.68 11.68 0 0 1-15.18-6.87l-33.07-90.26a11.46 11.46 0 0 1 7.03-14.78Z",
    style: {
      fill: "url(#linear-gradient-111)"
    },
    transform: "translate(-94.25 -69.15)"
  }), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M504.95 275.56c-4.13 1.34-10.6 3.7-14.78 5.26a3.93 3.93 0 0 0-2.17 5.39l7.24 15a3.94 3.94 0 0 0 5.36 1.78l12.15-6.33a3.92 3.92 0 0 0 1.9-4.77l-4.79-13.87a3.92 3.92 0 0 0-4.91-2.46Z",
    className: "cls-21"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "m494.75 324.85 3.1 13.54a3.11 3.11 0 0 0 4.26 2.17l37.86-16.26c-1.72-5.53-3.45-11-5.16-16.21l-38 13.12a3.13 3.13 0 0 0-2.06 3.64Z",
    className: "cls-34"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M503.35 327.85a1.38 1.38 0 0 0-.78 1.73.24.24 0 0 0 0 .08 1.4 1.4 0 0 0 1.82.76l33.22-13.67c-.29-.89-.57-1.77-.85-2.65Z",
    className: "cls-21"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M589.46 356.17a.46.46 0 0 1 .26-.58l10.44-4.36a.46.46 0 0 1 .61.25.45.45 0 0 1-.25.61l-10.44 4.36a.47.47 0 0 1-.61-.25Z",
    style: {
      fill: "url(#linear-gradient-112)"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.94 357.56a.46.46 0 0 1 .27-.58l10.79-4.11a.47.47 0 0 1 .6.27.44.44 0 0 1-.26.6l-10.76 4.11a.47.47 0 0 1-.6-.27Z",
    style: {
      fill: "url(#linear-gradient-113)"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.59 359.43a.46.46 0 0 1 .26-.58c1.76-.7 10.55-4.21 10.73-4.27a.46.46 0 0 1 .31.87l-10.69 4.26a.45.45 0 0 1-.6-.26Zm11.29-4Z",
    style: {
      fill: "url(#linear-gradient-114)"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.16 362.5a.91.91 0 0 1 .54-1.16c10.41-4 10.68-4 10.85-4a.93.93 0 0 1 .24 1.83c-.64.19-6.71 2.51-10.43 3.94a.92.92 0 0 1-1.19-.54l-.01-.07Z",
    style: {
      fill: "url(#linear-gradient-115)"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.25 364.25a.46.46 0 0 1 .29-.59l10.67-3.66a.46.46 0 0 1 .59.28.45.45 0 0 1-.29.59l-10.67 3.69a.47.47 0 0 1-.59-.31Z",
    style: {
      fill: "url(#linear-gradient-116)"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.78 365.78a.46.46 0 0 1 .27-.58c3.69-1.37 9.68-3.65 10.35-4.08a.46.46 0 0 1 .46-.14.46.46 0 0 1 .33.56c-.07.29-.14.57-10.81 4.52a.47.47 0 0 1-.6-.27Z",
    style: {
      fill: "url(#linear-gradient-117)"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.68 354.15a.93.93 0 0 1 .53-1.16l11-4.45a.92.92 0 0 1 1.2.51 1 1 0 0 1-.51 1.21l-11 4.45a.94.94 0 0 1-1.21-.51s-.01-.03-.01-.05Z",
    style: {
      fill: "url(#linear-gradient-118)"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m682.15 87.15-7.14 21.44-11.45-14.05 18.59-7.39z",
    style: {
      fill: "url(#linear-gradient-119)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m684.11 111.88 41 70.07a5.73 5.73 0 0 0 8 1.94l68.8-43.8a2.28 2.28 0 0 0 1-2.35 2.31 2.31 0 0 0-1.79-1.83Z",
    style: {
      fill: "url(#linear-gradient-120)"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m682.14 87.15-92.29-44.42 81.21 51.52-1.72 6.03 12.8-13.13z",
    style: {
      fill: "url(#linear-gradient-121)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m664.46 98.42 10.55 10.17-3.95-14.34-6.6 4.17z",
    style: {
      fill: "url(#linear-gradient-122)"
    }
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "m689.57 118.38 3.18 2.37a1.001 1.001 0 1 1-1.19 1.61l-3.21-2.37a1.002 1.002 0 1 1 1.18-1.62ZM698.41 124.93l3.21 2.39a1 1 0 1 1-1.19 1.59l-3.21-2.39a1 1 0 0 1-.2-1.39 1 1 0 0 1 1.39-.21ZM707.22 131.53l3.19 2.42a1 1 0 1 1-1.2 1.58l-3.19-2.42a1 1 0 1 1 1.19-1.58ZM715.97 138.2l3.17 2.44a1 1 0 0 1 .18 1.39 1 1 0 0 1-1.39.17l-3.18-2.43a1 1 0 1 1 1.2-1.57ZM724.67 144.94l3.15 2.48a1 1 0 1 1-1.22 1.54l-3.14-2.47a1 1 0 0 1-.18-1.38 1 1 0 0 1 1.39-.17ZM733.3 151.78l3.12 2.5a1 1 0 0 1-1.23 1.53l-3.11-2.5a1 1 0 0 1-.16-1.38 1 1 0 0 1 1.38-.16ZM741.86 158.71l3.09 2.54a1 1 0 0 1-1.24 1.51l-3.09-2.54a1 1 0 0 1-.14-1.38 1 1 0 0 1 1.37-.14ZM750.33 165.74l3.06 2.59a1 1 0 0 1-1.26 1.48l-3-2.58a1 1 0 0 1-.13-1.37 1 1 0 0 1 1.38-.12ZM758.75 172.9l3 2.63a1 1 0 1 1-1.27 1.46l-3-2.63a1 1 0 0 1 1.27-1.46ZM766.97 180.18l3 2.68a1 1 0 1 1-1.3 1.43l-3-2.67a1 1 0 1 1 1.29-1.43ZM775.11 187.6l2.93 2.73a1 1 0 1 1-1.31 1.4l-2.92-2.72a1 1 0 1 1 1.31-1.4ZM783.13 195.16l2.87 2.79a1 1 0 0 1-1.33 1.37l-2.87-2.78a1 1 0 0 1 0-1.36 1 1 0 0 1 1.35 0ZM790.99 202.85l2.82 2.85a1 1 0 0 1-1.36 1.34l-2.81-2.84a1 1 0 1 1 1.36-1.34ZM798.68 210.77l2.76 2.91a1 1 0 0 1-1.38 1.31l-2.74-2.9a1 1 0 0 1 0-1.35 1 1 0 0 1 1.34 0ZM806.2 218.85l2.68 3a1 1 0 0 1-.07 1.34.94.94 0 0 1-1.33-.07l-2.67-3a.94.94 0 0 1 .07-1.33 1 1 0 0 1 1.34.06ZM813.51 227.09l2.6 3.05a.94.94 0 0 1-1.43 1.22l-2.59-3a.944.944 0 1 1 1.44-1.22ZM820.59 235.54l2.52 3.12a.94.94 0 0 1-.15 1.32.93.93 0 0 1-1.31-.14l-2.5-3.11a.94.94 0 0 1 1.46-1.18ZM827.42 244.2l2.42 3.2a.932.932 0 0 1-1.49 1.12l-2.4-3.18a.932.932 0 1 1 1.49-1.12ZM833.98 253.07l2.31 3.28a.934.934 0 0 1-1.53 1.07l-2.3-3.26a.934.934 0 0 1 1.53-1.07ZM840.22 262.17l2.19 3.36a.93.93 0 1 1-1.55 1l-2.18-3.34a.93.93 0 1 1 1.55-1ZM846.12 271.49l2 3.45a.92.92 0 0 1-1.58.94l-2-3.42a.93.93 0 0 1 1.59-.95ZM851.64 281.05l1.9 3.53a.92.92 0 1 1-1.61.87l-1.89-3.5a.92.92 0 0 1 1.62-.87ZM856.75 290.85l1.74 3.62a.91.91 0 1 1-1.64.79l-1.73-3.59a.93.93 0 0 1 .43-1.23.92.92 0 0 1 1.2.41ZM861.37 300.85l1.56 3.7a.912.912 0 0 1-1.68.71l-1.55-3.66a.9.9 0 0 1 .48-1.19.92.92 0 0 1 1.2.48ZM865.49 311.11l1.37 3.77a.91.91 0 0 1-1.71.62l-1.4-3.76a.91.91 0 0 1 1.71-.61ZM869.07 321.56l1.15 3.85a.902.902 0 1 1-1.73.51l-1.15-3.82a.91.91 0 0 1 1.74-.52ZM872.05 332.2l.93 3.91a.9.9 0 0 1-.67 1.08.89.89 0 0 1-1.08-.67l-.92-3.87a.904.904 0 0 1 1.76-.41ZM874.4 343l.69 4a.9.9 0 0 1-1.77.3l-.69-3.92a.89.89 0 0 1 .73-1 .9.9 0 0 1 1 .73ZM876.08 353.92l.44 4a.89.89 0 0 1-1.77.19l-.45-3.95a.9.9 0 1 1 1.78-.2ZM877.07 364.93l.19 4a.89.89 0 1 1-1.78.08l-.18-4a.9.9 0 0 1 .85-.94.89.89 0 0 1 .93.85ZM877.36 375.98l-.07 4a.89.89 0 1 1-1.77 0l.07-4a.89.89 0 0 1 1.77 0ZM876.95 387.02l-.33 4a.89.89 0 0 1-1 .81.88.88 0 0 1-.8-.95l.32-4a.883.883 0 0 1 1.76.14ZM875.84 398.02l-.57 4a.88.88 0 1 1-1.74-.25l.57-3.94a.88.88 0 0 1 1-.75.89.89 0 0 1 .75 1ZM874.05 408.92l-.81 3.94a.873.873 0 0 1-1.71-.35l.8-3.9a.873.873 0 0 1 1.71.35ZM871.62 419.71l-1 3.87a.865.865 0 1 1-1.67-.45l1-3.84a.87.87 0 0 1 1.68.45ZM868.53 430.31l-1.29 3.81a.87.87 0 0 1-1.1.54.85.85 0 0 1-.54-1.09l1.28-3.77a.87.87 0 0 1 1.1-.54.86.86 0 0 1 .55 1.09ZM864.75 440.71l-1.52 3.72a.87.87 0 1 1-1.6-.66l1.51-3.68a.87.87 0 0 1 1.6.66ZM860.38 450.85l-1.75 3.61a.854.854 0 0 1-1.54-.74l1.73-3.58a.861.861 0 1 1 1.55.75ZM855.39 460.7l-1.95 3.51a.86.86 0 0 1-1.5-.83l1.94-3.48a.85.85 0 0 1 1.16-.33.85.85 0 0 1 .33 1.16ZM849.84 470.24l-2.15 3.4a.852.852 0 0 1-1.44-.91l2.13-3.36a.86.86 0 0 1 1.18-.26.85.85 0 0 1 .26 1.17ZM843.75 479.46l-2.33 3.27a.848.848 0 1 1-1.37-1l2.31-3.25a.86.86 0 0 1 1.19-.2.85.85 0 0 1 .2 1.18ZM837.21 488.35l-2.5 3.14a.83.83 0 0 1-1.18.14.86.86 0 0 1-.14-1.19l2.48-3.12a.83.83 0 0 1 1.18-.14.84.84 0 0 1 .14 1.19ZM830.21 496.85l-2.64 3a.84.84 0 1 1-1.26-1.1l2.62-3a.84.84 0 1 1 1.26 1.1ZM822.82 505.08l-2.79 2.89a.835.835 0 1 1-1.2-1.16l2.76-2.87a.83.83 0 0 1 1.18 0 .84.84 0 0 1 0 1.19ZM815.06 512.92l-2.91 2.77a.831.831 0 0 1-1.15-1.2l2.89-2.75a.82.82 0 0 1 1.17 0 .82.82 0 0 1 0 1.17ZM806.96 520.43l-3 2.65a.83.83 0 0 1-1.17-.08.83.83 0 0 1 .08-1.17l3-2.63a.84.84 0 0 1 1.17.08.83.83 0 0 1-.08 1.17ZM798.58 527.6l-3.12 2.52a.83.83 0 0 1-1.16-.12.84.84 0 0 1 .12-1.16l3.1-2.52a.82.82 0 0 1 1.16.12.83.83 0 0 1-.12 1.16ZM789.92 534.44l-3.17 2.41a.824.824 0 0 1-1-1.31l3.19-2.39a.82.82 0 0 1 1.15.17.83.83 0 0 1-.17 1.15ZM781.02 540.95l-3.27 2.29a.8.8 0 0 1-1.13-.2.82.82 0 0 1 .2-1.14l3.27-2.28a.82.82 0 0 1 1.14.2.83.83 0 0 1-.21 1.14ZM771.91 547.15l-3.37 2.18a.81.81 0 0 1-1.12-.24.8.8 0 0 1 .24-1.12l3.35-2.17a.813.813 0 1 1 .89 1.36ZM762.59 553.05l-3.44 2.07a.81.81 0 1 1-.83-1.39l3.41-2.06a.812.812 0 0 1 .84 1.39ZM753.09 558.64l-3.5 2a.8.8 0 0 1-1.09-.3.81.81 0 0 1 .3-1.1l3.48-2a.804.804 0 1 1 .79 1.4ZM743.42 563.94l-3.55 1.91a.8.8 0 0 1-1.08-.34.81.81 0 0 1 .34-1.08l3.53-1.85a.81.81 0 0 1 1.09.27.79.79 0 0 1-.34 1.08ZM733.61 568.96l-3.61 1.75a.79.79 0 0 1-1.06-.36.8.8 0 0 1 .37-1.07l3.59-1.75a.8.8 0 0 1 1.07.36.81.81 0 0 1-.37 1.07ZM723.65 573.69l-3.65 1.66a.795.795 0 1 1-.65-1.45l3.63-1.65a.79.79 0 1 1 .65 1.44ZM713.57 578.15l-3.69 1.55a.79.79 0 0 1-.61-1.45l3.68-1.55a.79.79 0 1 1 .61 1.45ZM703.38 582.33l-3.74 1.46a.77.77 0 0 1-1-.45.79.79 0 0 1 .44-1l3.72-1.45a.784.784 0 0 1 .57 1.46ZM693.07 586.25l-3.77 1.35a.781.781 0 1 1-.53-1.47l3.76-1.36a.79.79 0 0 1 1 .47.77.77 0 0 1-.47 1ZM682.67 589.85l-3.81 1.26a.78.78 0 1 1-.48-1.48l3.79-1.25a.78.78 0 0 1 1 .5.76.76 0 0 1-.49 1ZM672.17 593.25l-3.83 1.16a.78.78 0 1 1-.45-1.49l3.82-1.15a.76.76 0 0 1 1 .51.78.78 0 0 1-.51 1ZM661.6 596.34l-3.87 1a.77.77 0 1 1-.41-1.48l3.85-1.06a.773.773 0 0 1 .41 1.49ZM650.94 599.15l-3.89 1a.77.77 0 1 1-.37-1.49l3.88-1a.77.77 0 1 1 .37 1.49ZM640.21 601.67l-3.92.85a.762.762 0 0 1-.32-1.49l3.9-.85a.762.762 0 1 1 .32 1.49ZM629.42 603.9l-3.94.74a.77.77 0 0 1-.89-.61.75.75 0 0 1 .61-.88l3.92-.73a.76.76 0 0 1 .28 1.49ZM618.56 605.85l-4 .62a.75.75 0 0 1-.81-.62.76.76 0 0 1 .63-.86l3.94-.62a.754.754 0 0 1 .23 1.49ZM607.67 607.45l-4 .54a.75.75 0 1 1-.2-1.48l4-.55a.76.76 0 0 1 .85.65.74.74 0 0 1-.64.84ZM596.75 608.85l-4 .46a.74.74 0 0 1-.82-.66.74.74 0 0 1 .65-.83l4-.46a.75.75 0 0 1 .17 1.49ZM585.75 610.06l-4 .38a.743.743 0 0 1-.14-1.48l4-.38a.743.743 0 0 1 .14 1.48ZM574.82 611.03l-4 .3a.76.76 0 0 1-.8-.69.74.74 0 0 1 .73-.79l4-.3a.74.74 0 0 1 .79.69.73.73 0 0 1-.68.79ZM563.83 611.77l-4 .2a.73.73 0 0 1-.77-.69.74.74 0 0 1 .69-.78l4-.21a.741.741 0 0 1 .08 1.48ZM552.82 612.26l-4 .12a.73.73 0 1 1 0-1.46l4-.12a.75.75 0 0 1 .76.72.74.74 0 0 1-.72.75ZM541.81 612.51h-4a.73.73 0 1 1 0-1.46h4a.74.74 0 0 1 .74.73.73.73 0 0 1-.73.73ZM530.8 612.51l-4-.06a.73.73 0 0 1-.71-.74.71.71 0 0 1 .73-.71l4 .06a.73.73 0 0 1 0 1.45ZM519.75 612.25l-4-.16a.71.71 0 0 1-.69-.74.73.73 0 0 1 .75-.7l4 .16a.72.72 0 1 1-.06 1.44ZM508.75 611.73l-4-.25a.73.73 0 0 1-.67-.76.72.72 0 0 1 .76-.67l4 .25a.72.72 0 0 1 .67.76.71.71 0 0 1-.76.67ZM497.75 610.95l-4-.35a.72.72 0 0 1-.65-.78.71.71 0 0 1 .77-.64l4 .35a.7.7 0 0 1 .65.77.72.72 0 0 1-.77.65ZM486.82 609.85l-4-.45a.7.7 0 0 1-.62-.78.71.71 0 0 1 .78-.63l4 .45a.72.72 0 0 1 .63.79.7.7 0 0 1-.79.62ZM475.89 608.57l-4-.56a.7.7 0 0 1-.6-.79.69.69 0 0 1 .79-.6l4 .55a.71.71 0 0 1 .61.79.72.72 0 0 1-.8.61ZM464.99 606.96l-4-.65a.7.7 0 1 1 .23-1.38l3.94.64a.7.7 0 0 1 .58.8.71.71 0 0 1-.81.58ZM454.14 605.08l-3.94-.76a.68.68 0 0 1-.55-.81.7.7 0 0 1 .81-.56l3.92.74a.68.68 0 0 1 .55.81.69.69 0 0 1-.81.56ZM443.33 602.92l-3.91-.86a.7.7 0 1 1 .3-1.36l3.9.85a.69.69 0 0 1 .53.83.7.7 0 0 1-.83.53ZM432.59 600.47l-3.89-1a.68.68 0 0 1-.5-.83.67.67 0 0 1 .83-.5l3.88.95a.69.69 0 1 1-.33 1.34ZM421.92 597.75l-3.87-1.06a.69.69 0 1 1 .37-1.32l3.85 1.05a.69.69 0 0 1-.36 1.33ZM411.32 594.74l-3.84-1.16a.68.68 0 1 1 .4-1.3l3.83 1.15a.68.68 0 1 1-.39 1.3ZM400.8 591.46l-3.8-1.26a.67.67 0 0 1-.43-.86.68.68 0 0 1 .86-.43l3.79 1.26a.68.68 0 0 1 .43.86.67.67 0 0 1-.86.43ZM390.37 587.9l-3.76-1.36a.67.67 0 0 1-.41-.86.68.68 0 0 1 .86-.41l3.76 1.35a.68.68 0 1 1-.46 1.27ZM380.04 584.07l-3.73-1.46a.67.67 0 0 1-.38-.86.68.68 0 0 1 .87-.39l3.72 1.45a.67.67 0 0 1 .38.87.66.66 0 0 1-.87.38ZM369.81 580l-3.7-1.52a.67.67 0 0 1 .51-1.23l3.7 1.51a.68.68 0 0 1 .37.87.67.67 0 0 1-.87.37ZM359.65 575.79l-3.68-1.56a.663.663 0 1 1 .52-1.22l3.68 1.55a.67.67 0 0 1-.52 1.23ZM349.53 571.47l-3.67-1.6a.66.66 0 0 1-.34-.86.67.67 0 0 1 .87-.35l3.67 1.59a.66.66 0 0 1 .34.87.65.65 0 0 1-.86.35ZM339.45 567.06l-3.7-1.62a.66.66 0 0 1-.33-.87.64.64 0 0 1 .86-.33l3.66 1.62a.66.66 0 1 1-.53 1.2ZM329.39 562.59l-3.64-1.64a.653.653 0 1 1 .54-1.19l3.65 1.63a.67.67 0 0 1 .33.87.66.66 0 0 1-.86.33ZM319.35 558.07l-3.6-1.65a.65.65 0 0 1-.33-.85.66.66 0 0 1 .86-.33l3.65 1.65a.65.65 0 0 1-.53 1.18ZM309.33 553.54l-3.65-1.69a.64.64 0 0 1-.32-.85.64.64 0 0 1 .85-.32l3.65 1.64a.65.65 0 0 1 .32.86.64.64 0 0 1-.85.32ZM299.3 549.01l-3.65-1.64a.642.642 0 1 1 .53-1.17l3.65 1.64a.642.642 0 0 1-.53 1.17ZM289.26 544.51l-3.66-1.66a.64.64 0 0 1-.32-.84.63.63 0 0 1 .84-.32l3.66 1.62a.64.64 0 0 1-.52 1.17ZM279.2 540.05l-3.66-1.6a.63.63 0 0 1-.33-.84.63.63 0 0 1 .83-.32l3.71 1.56a.634.634 0 1 1-.51 1.16ZM269.11 535.67l-3.67-1.58a.63.63 0 1 1 .49-1.15l3.68 1.57a.62.62 0 0 1 .33.82.63.63 0 0 1-.82.34ZM258.99 531.37l-3.69-1.52a.623.623 0 1 1 .48-1.15l3.69 1.53a.623.623 0 1 1-.48 1.15ZM248.83 527.2l-3.71-1.49a.61.61 0 0 1-.35-.8.62.62 0 0 1 .81-.35l3.71 1.48a.624.624 0 0 1-.46 1.16ZM238.61 523.16l-3.73-1.43a.61.61 0 0 1-.36-.79.62.62 0 0 1 .8-.36l3.73 1.43a.62.62 0 0 1 .36.8.61.61 0 0 1-.8.35ZM228.33 519.29l-3.75-1.37a.61.61 0 0 1-.38-.78.62.62 0 0 1 .79-.37l3.76 1.36a.62.62 0 0 1 .37.79.62.62 0 0 1-.79.37ZM217.98 515.6l-3.78-1.29a.6.6 0 0 1-.38-.77.61.61 0 0 1 .77-.39l3.79 1.29a.61.61 0 0 1 .38.78.6.6 0 0 1-.77.38ZM207.57 512.12l-3.82-1.21a.603.603 0 1 1 .36-1.15l3.82 1.2a.61.61 0 1 1-.37 1.16ZM197.08 508.85l-3.84-1.11a.62.62 0 0 1-.41-.75.61.61 0 0 1 .75-.41l3.85 1.12a.6.6 0 0 1 .41.74.61.61 0 0 1-.75.42ZM186.5 505.93l-3.87-1a.6.6 0 1 1 .29-1.16l3.89 1a.59.59 0 0 1 .43.73.58.58 0 0 1-.72.43ZM175.82 503.39l-3.91-.82a.6.6 0 0 1 .24-1.17l3.92.83a.58.58 0 0 1 .46.7.59.59 0 0 1-.7.46ZM165.05 501.26l-3.93-.67a.593.593 0 0 1 .2-1.17l3.95.67a.59.59 0 0 1 .48.69.58.58 0 0 1-.68.48ZM154.21 499.55l-4-.51a.58.58 0 0 1-.5-.65.58.58 0 0 1 .65-.51l4 .51a.6.6 0 0 1 .51.66.59.59 0 0 1-.66.51ZM143.31 498.27l-4-.35a.59.59 0 0 1 .11-1.17l4 .36a.582.582 0 0 1-.1 1.16ZM132.37 497.44l-4-.2a.58.58 0 1 1 0-1.15l4 .19a.57.57 0 0 1 .55.6.59.59 0 0 1-.61.56ZM121.39 497.05h-.78a.58.58 0 1 1 0-1.15h.79a.57.57 0 0 1 .57.58.58.58 0 0 1-.59.57Z",
    className: "cls-21"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M832.22 718.89a2.41 2.41 0 0 0-.06-.59c-2.95-11.67-15-17.66-15-17.66l-5.79.46c-3.33 10.29-5.48 15.31-4.94 18.12a1.55 1.55 0 0 0 .06.23 136.7 136.7 0 0 0 25.73-.56Z",
    style: {
      fill: "url(#linear-gradient-123)"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M806.5 719.45a2.52 2.52 0 0 0 1.84 1.86c6.79 1.43 17.6.28 22.13-.32a2.11 2.11 0 0 0 1.75-2.1 136.7 136.7 0 0 1-25.72.56Z",
    style: {
      fill: "url(#linear-gradient-124)"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m821.94 691.63-2.53 12.21a2 2 0 0 1-1.71 1.64 16.92 16.92 0 0 1-3.93-.06 2.51 2.51 0 0 1-2-2.95l1.77-10.84Z",
    style: {
      fill: "url(#linear-gradient-125)"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M757.29 719.35c6.18-.17 9.38-.9 11-1.58v1.89a1.22 1.22 0 0 1-1.17 1.24l-34-.22a1.54 1.54 0 0 1-1.25-2.25c4.51.37 15.86 1.19 25.42.92Z",
    style: {
      fill: "url(#linear-gradient-126)"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M731.93 718.43a2.1 2.1 0 0 1 .13-.26c3-4.19 10.64-12.54 25.74-16.16l7.24-.22s3.23 5.6 3.29 16c-1.66.68-4.86 1.41-11 1.58-9.6.25-20.95-.57-25.4-.94Z",
    style: {
      fill: "url(#linear-gradient-127)"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M766.38 690.81c-.08.54-1.07 8.75-1.45 11.93a1.58 1.58 0 0 1-1.33 1.42 16.48 16.48 0 0 1-5-.08 2.13 2.13 0 0 1-1.62-2.15v-12.88Z",
    style: {
      fill: "url(#linear-gradient-128)"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M817.1 530s11.59 103 5.15 167.39c0 0-7.72 0-11.58-1.29 0 0-12-100.71-15.94-129.53a1 1 0 0 0-1.91-.06c-4.81 24.24-23.69 119.32-25.93 128.3 0 0-6.44 2.58-11.59 0 0 0 10.3-137.77 18-162.23Z",
    style: {
      fill: "url(#linear-gradient-129)"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M840.28 411.58s-48.93-7.72-87.56 2.58l2.58 39.91s10.3 55.37 18 79.83c0 0 29.61 5.15 43.77-2.57 0 0 11.59-69.53 18-79.83.06 0 6.5-27.04 5.21-39.92Z",
    style: {
      fill: "url(#linear-gradient-130)"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m806.29 376.4 4.87 33s-13.61 6.26-23.15-.27l2-23.26Z",
    style: {
      fill: "url(#linear-gradient-131)"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M782.5 357.22c-.16.32-2.57 19.09-4.06 30.72a8.09 8.09 0 0 0 7.94 9.11l4.43.06A15.77 15.77 0 0 0 806.69 383l2.21-21s-22.58-12.55-26.4-4.78Z",
    style: {
      fill: "url(#linear-gradient-132)"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M813.67 361.78c1.6-2.18 2.91-5.66-.86-9.07s-7.93-2.36-10.5-1a2.92 2.92 0 0 1-3.46-.52 1.85 1.85 0 0 0-1.76-.56 2.71 2.71 0 0 1-3.18-2.22c-.44-2.6-2-5.62-6.65-6.3-8.57-1.24-12.4 7.46-12 13.43s9.8 6.78 15 5.54c3.85-.91 7.36 2.34 9 4.13a2.8 2.8 0 0 1 .66 2.38l-1.07 5.84a27.31 27.31 0 0 0 3.39 5 5.78 5.78 0 0 0 3.16 1.83c1.45-3 5.85-3.73 7.91-3.9a2.81 2.81 0 0 0 2-1.06c1.47-1.85 3.71-5.94-1.12-9.62a2.82 2.82 0 0 1-.52-3.9Z",
    style: {
      fill: "url(#linear-gradient-133)"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M804.18 386.49s-.31-10.43 3.87-11.61 8.86 1.66 5.55 8.07c-4.12 7.97-9.42 3.54-9.42 3.54Z",
    style: {
      fill: "url(#linear-gradient-134)"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M840.28 411.58s76 82.41-13.52 114v-6.44s33.48-28.32 7.73-67c0 0 3.21-36.7 5.79-40.56Z",
    style: {
      fill: "url(#linear-gradient-135)"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M752.72 414.16S673.54 494 763 525.53v-6.44s-33.48-28.32-7.73-67c.03.05 2.6-31.49-2.55-37.93Z",
    style: {
      fill: "url(#linear-gradient-136)"
    },
    transform: "translate(-94.25 -69.15)"
  }), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M683.3 287.11a.38.38 0 0 1-.36-.27c-2-7 6-11.05 6.06-11.09a.37.37 0 0 1 .5.16.39.39 0 0 1-.17.51c-.08 0-7.47 3.79-5.67 10.22a.37.37 0 0 1-.26.46Z",
    className: "cls-21"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M825 522.29s2.46 4.12 5.79 3.25 5.09-6.46 2.13-7-8.21-.04-7.92 3.75Z",
    style: {
      fill: "url(#linear-gradient-137)"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M758 522.29s2.46 4.12 5.79 3.25 5.09-6.46 2.13-7-8.21-.04-7.92 3.75Z",
    style: {
      fill: "url(#linear-gradient-138)"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.44 511.46V460.1a12.31 12.31 0 0 1 12.17-12.32c20.25-.22 62-.23 96.2 2.65a9.24 9.24 0 0 1 8.46 8.89l3.2 49.67a11.77 11.77 0 0 1-11.53 12.18L746.2 523a11.55 11.55 0 0 1-11.76-11.54Z",
    style: {
      fill: "url(#linear-gradient-139)"
    },
    transform: "translate(-94.25 -69.15)"
  }), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M651.92 396.5c-.09 4.38 0 11.31.15 15.79a4 4 0 0 0 4.42 3.84l16.66-2a4 4 0 0 0 3.46-4.51l-2.05-13.65a4 4 0 0 0-3.91-3.37h-14.77a3.94 3.94 0 0 0-3.96 3.9Z",
    className: "cls-21"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "m695.48 422.37 13.9 1.5a3.13 3.13 0 0 0 3.46-3.35l-3-41.36c-5.82-.18-11.57-.32-17.12-.41v40.5a3.14 3.14 0 0 0 2.76 3.12Z",
    className: "cls-34"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M701.18 415.2a1.39 1.39 0 0 0 1.39 1.32h.08a1.41 1.41 0 0 0 1.32-1.48l-2.1-36.1-2.8-.06Z",
    className: "cls-21"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M753.88 478.68a.47.47 0 0 1-.47-.43l-.72-11.37a.47.47 0 0 1 .44-.5.46.46 0 0 1 .49.44l.72 11.37a.46.46 0 0 1-.43.49Z",
    style: {
      fill: "url(#linear-gradient-140)"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M755.36 478.68a.47.47 0 0 1-.47-.45l-.37-11.58a.47.47 0 0 1 .45-.49.45.45 0 0 1 .48.45l.38 11.59a.46.46 0 0 1-.45.48Z",
    style: {
      fill: "url(#linear-gradient-141)"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M757.35 478.68a.45.45 0 0 1-.46-.44c-.09-1.91-.55-11.42-.55-11.61a.47.47 0 1 1 .93 0c0 .25.36 7.67.55 11.57a.47.47 0 0 1-.45.48Zm-.08-12.05Z",
    style: {
      fill: "url(#linear-gradient-142)"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M760.46 479.15a.94.94 0 0 1-.93-.9c-.4-11.23-.33-11.48-.28-11.65a.93.93 0 0 1 1.82.37c0 .68.18 7.21.32 11.21a.93.93 0 0 1-.9 1Z",
    style: {
      fill: "url(#linear-gradient-143)"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M762.48 478.68a.46.46 0 0 1-.47-.46v-11.37a.47.47 0 1 1 .94 0v11.37a.46.46 0 0 1-.47.46Z",
    style: {
      fill: "url(#linear-gradient-144)"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M764.11 478.68a.46.46 0 0 1-.46-.45c-.09-4-.3-10.41-.49-11.18a.47.47 0 0 1 .66-.62c.26.17.5.33.76 11.78a.47.47 0 0 1-.46.47Z",
    style: {
      fill: "url(#linear-gradient-145)"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M751.37 479.72a.93.93 0 0 1-.93-.89l-.62-11.93a.92.92 0 0 1 .88-1 .93.93 0 0 1 1 .88l.62 11.94a.94.94 0 0 1-.88 1Z",
    style: {
      fill: "url(#linear-gradient-146)"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M830.28 520.92s-11.59-7.73-16.74-5.15-5.15 6.43-5.15 6.43 2.58 5.15 6.44 3.87c3.29-1.1 10.32.61 14.72.34a2.48 2.48 0 0 0 2.32-2.29c.13-1.46-.09-3.2-1.59-3.2Z",
    style: {
      fill: "url(#linear-gradient-147)"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M779.82 514.6c-5.15-2.58-16.73 5.15-16.73 5.15-1.56 0-1.71 1.88-1.58 3.36a2.32 2.32 0 0 0 2.15 2.12c4.38.32 11.55-1.44 14.88-.33 3.86 1.28 6.46-3.9 6.46-3.9s0-3.83-5.18-6.4Z",
    style: {
      fill: "url(#linear-gradient-148)"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m926.28 583.16-5-2.71a4.81 4.81 0 0 1-2.38-3.1l-4.3-18.15 8.47.24Z",
    style: {
      fill: "url(#linear-gradient-149)"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M918.29 437.29s-16 54.3-3.73 121.91c0 0 2.56 3.68 8.47.24 0 0-.48-81.69 4.84-96.07Z",
    style: {
      fill: "url(#linear-gradient-150)"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m950.15 709.79 1 2.36-.39 8.47a2.62 2.62 0 0 1-2.31 2.39 30.82 30.82 0 0 1-6.76.37 2.55 2.55 0 0 1-2.34-3.52l2.86-6.11a3.68 3.68 0 0 1 2.16-2Z",
    style: {
      fill: "url(#linear-gradient-151)",
      fillRule: "evenodd"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M953.14 632.93s0 61.47-2.89 78.78a2.11 2.11 0 0 1-1.72 1.75 5.54 5.54 0 0 1-3.24-.48 2.07 2.07 0 0 1-1.2-1.67L935.92 634Z",
    style: {
      fill: "url(#linear-gradient-152)",
      fillRule: "evenodd"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m960.43 709.79-1 2.36-.69 8.47a2.63 2.63 0 0 0 2.31 2.39 41.84 41.84 0 0 0 7.84.37 2.55 2.55 0 0 0 2.34-3.52l-2.85-6.11a3.74 3.74 0 0 0-2.16-2Z",
    style: {
      fill: "url(#linear-gradient-153)",
      fillRule: "evenodd"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M957.44 632.93s0 62.28 3 79.19a1.49 1.49 0 0 0 1 1.19 5.41 5.41 0 0 0 4.15-.46 1.57 1.57 0 0 0 .87-1.22l8.21-77.63Z",
    style: {
      fill: "url(#linear-gradient-154)",
      fillRule: "evenodd"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M976.86 643c-5.56 1-13.4 1-21 1l-1-3.72-2.09 3.72c-1.17 0-2.33-.28-3.46-.31l-9.31-6.51-4.1 5.6a21.67 21.67 0 0 0-3.18 0C920.64 587 919.88 532 928.4 512h47.39c20.76 16 1.07 131 1.07 131Z",
    style: {
      fill: "url(#linear-gradient-155)"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m990.16 437.29-10.11 33.54-4.26 40.46c-19.17 6.39-47.38 0-47.38 0l-.54-33-9.65-41C922.56 428 930 421.2 936 417.18a47.52 47.52 0 0 1 7.24-4.37l12.28.54a53.81 53.81 0 0 1 9.7 3.18 58 58 0 0 1 24.94 20.76Z",
    style: {
      fill: "url(#linear-gradient-156)"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M990.16 437.29s38.87 60.15-5.85 87.84l-4.08-5.8s21.11-30.94 1.41-58.62Z",
    style: {
      fill: "url(#linear-gradient-157)"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M980.05 519.27S969.93 523 969.4 531s.53 10.12 2.13 7.46 3.19-5.33 6.39-7.46a38.43 38.43 0 0 0 6.39-5.85s-.54-5.88-4.26-5.88Z",
    style: {
      fill: "url(#linear-gradient-158)"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M970 420.68s-2.07 5.85-1.7 6 10.73 5.25 10.73 4.64-9.03-10.64-9.03-10.64Z",
    style: {
      fill: "url(#linear-gradient-159)"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M965.24 416.52c-6.71 10.9-20.07 31.06-25.57 29.23-7.5-2.5-3.67-28.57-3.67-28.57a47.52 47.52 0 0 1 7.24-4.37l12.28.54a54 54 0 0 1 9.72 3.17Z",
    style: {
      fill: "url(#linear-gradient-160)"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M942.25 397.89v20.18a3.29 3.29 0 0 0 2.8 3.26 25.21 25.21 0 0 0 10.36-.35 3.32 3.32 0 0 0 2.31-3.81L954 397.89Z",
    style: {
      fill: "url(#linear-gradient-161)"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M934.8 368.34s-12.78 34.08 3.46 38.21c19.11 4.87 25.55-20.37 25.55-20.37S947 338 934.8 368.34Z",
    style: {
      fill: "url(#linear-gradient-162)"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M968.93 370.25s-6.9-13.3-1.34-18.78 15.9-3.06 17.37 7.86-12.66 22.8-16.03 10.92Z",
    style: {
      fill: "url(#linear-gradient-163)"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M929.62 365.52a3.84 3.84 0 0 0 4.57 4.75 38 38 0 0 1 9.39-1.13c20.5.8 12.51 14.11 12.51 16.24 0 4.35 4.28-2.27 4.52-.8.54 3.2-2 12.89-2 12.89s13.14-2.77 17.39-9.16-.53-20.76-2.13-26.09-12.24-10.65-18.1-10.11c-5.18.47-21.91-2.03-26.15 13.41Z",
    style: {
      fill: "url(#linear-gradient-164)"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M958 388.31s1.6-8 5.86-6.39-3.2 10.65-5.86 12.24Z",
    style: {
      fill: "url(#linear-gradient-165)"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M853.61 585.09a4.18 4.18 0 0 0-6.08 3.12c-1.38 9.91-4 33.68.6 48.09l4 .12s0-34.61 3.82-43.39c1.94-4.34.05-6.68-2.34-7.94Z",
    style: {
      fill: "url(#linear-gradient-166)",
      fillRule: "evenodd"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m849.7 633.1-1.57 3.19s-1.84 5-1.69 8.39 4.91 4.27 6.53 4.24 1.75-1.66.12-4.38a14 14 0 0 0-1.55-9.93Z",
    style: {
      fill: "url(#linear-gradient-167)",
      fillRule: "evenodd"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m878.15 711.55-.88 2.16.36 7.76a2.4 2.4 0 0 0 2.12 2.19 28.31 28.31 0 0 0 6.19.34 2.34 2.34 0 0 0 2.15-3.23l-2.62-5.6a3.38 3.38 0 0 0-2-1.78Z",
    style: {
      fill: "url(#linear-gradient-168)",
      fillRule: "evenodd"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M871.1 651.62s4.32 48.07 7.16 62.78c0 0 2.14 1.55 5.32-.45l3.87-64.15Z",
    style: {
      fill: "url(#linear-gradient-169)",
      fillRule: "evenodd"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m862.58 711.55.88 2.16-.36 7.76a2.4 2.4 0 0 1-2.12 2.19 28.27 28.27 0 0 1-6.19.34 2.33 2.33 0 0 1-2.14-3.23l2.61-5.6a3.41 3.41 0 0 1 2-1.78Z",
    style: {
      fill: "url(#linear-gradient-170)",
      fillRule: "evenodd"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M868.17 650.92s-2.86 48.77-5.7 63.48c0 0-2.13 1.55-5.32-.45l-3.87-64.15Z",
    style: {
      fill: "url(#linear-gradient-171)",
      fillRule: "evenodd"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m886.71 623-34.27 1.5-2.28 66.74a1.18 1.18 0 0 0 1 1.2l15.93 3a1.24 1.24 0 0 0 1-.24 1.16 1.16 0 0 0 .43-.89l1-47.61 4.41 47.82a1.18 1.18 0 0 0 1.28 1.07l13.68-1.29a1.16 1.16 0 0 0 1.06-1.22Z",
    style: {
      fill: "url(#linear-gradient-172)",
      fillRule: "evenodd"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M885.54 587.73a4.18 4.18 0 0 0-3.14-3.73c-18.16-4.62-32.28.61-32.28.61l2.17 44.39 34.62-1.57c.93-5.85-.75-31.05-1.37-39.7Z",
    style: {
      fill: "url(#linear-gradient-173)",
      fillRule: "evenodd"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M885.11 533.47c-1.57-3-5.81-8.06-15.29-4.32a3.89 3.89 0 0 1-2.08.22c-3.39-.59-14-1.33-14.59 12.14a3.77 3.77 0 0 1-.51 1.75c-.95 1.6-2.82 5.34-1.39 7.78a3.86 3.86 0 0 1 .49 2.42c-.45 3.39-.34 11.35 10.32 11.67a3.61 3.61 0 0 1 1.57.39l10.79 5.33a3.71 3.71 0 0 1 1.43 1.23c.86 1.23 2.9 3.33 5.86 1.37a3.84 3.84 0 0 1 2-.64c2.58-.08 8.69-1 10.21-8a3.79 3.79 0 0 1 1.16-2c1.78-1.63 5.24-5.65 2.81-10.53a3.65 3.65 0 0 1-.34-2.36c.7-3.52 1.59-13.24-9.55-14.51a3.79 3.79 0 0 1-2.89-1.94Z",
    style: {
      fill: "url(#linear-gradient-174)",
      fillRule: "evenodd"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m862.17 566.76-1.49 14.74a2.33 2.33 0 0 0 1.8 2.51c2.63.61 7.38 1.32 11.37-.14a2.36 2.36 0 0 0 1.54-2.43l-1.46-15.15Z",
    style: {
      fill: "url(#linear-gradient-175)",
      fillRule: "evenodd"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M876.28 564.06s3.4-5.06 5.07-1.91-5.62 7.32-7.46 6.74 2.39-4.83 2.39-4.83Z",
    style: {
      fill: "url(#linear-gradient-176)",
      fillRule: "evenodd"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M858.26 542.59s-17.67 20.71-4.89 27.82 21.35-1.08 21.35-1.08S885.16 554.48 883 551s-21-11.44-24.74-8.41Z",
    style: {
      fill: "url(#linear-gradient-177)",
      fillRule: "evenodd"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M882.54 561.22s-11.68 7.46-11-14.21c0 0-6.31 4.86-7-1.1 0 0-10.23.75-10.23-3.47s16.54-11.32 25.56-.74 2.67 19.52 2.67 19.52Z",
    style: {
      fill: "url(#linear-gradient-178)",
      fillRule: "evenodd"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M886 587.32a3.65 3.65 0 0 0-5.08-2.65c-2.76 1.24-5.41 3.71-3 8.57 4.22 8.59 5.84 43.15 5.84 43.15l4-.3c3.96-14.97 0-39.4-1.76-48.77Z",
    style: {
      fill: "url(#linear-gradient-179)",
      fillRule: "evenodd"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m886 633 1.71 3.12s2.07 4.89 2.08 8.3-4.7 4.5-6.32 4.54-1.82-1.57-.33-4.37a14 14 0 0 1 1.08-10Z",
    style: {
      fill: "url(#linear-gradient-180)",
      fillRule: "evenodd"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M970.46 579.2a4.91 4.91 0 0 0-3.67 1.16 5 5 0 0 0-1.73 3.49c-.68 10.38-1.71 36.15 3.3 50.15h4s1.44-38.48 5-47.36c2.23-5.42-2.71-7.04-6.9-7.44Z",
    style: {
      fill: "url(#linear-gradient-181)",
      fillRule: "evenodd"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m969.83 630.64-1.47 3.24s-1.7 5-1.46 8.43 5 4.13 6.64 4.05 1.71-1.7 0-4.37a14 14 0 0 0-1.82-9.89Z",
    style: {
      fill: "url(#linear-gradient-182)",
      fillRule: "evenodd"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M983.27 718.46s.7 3.15 1 6a2.31 2.31 0 0 1-1.91 2.52 24.26 24.26 0 0 1-8.24.13 2.33 2.33 0 0 1-1.84-2.71c.3-1.51 2-3.47 4.21-5.18Z",
    style: {
      fill: "url(#linear-gradient-183)",
      fillRule: "evenodd"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M992.9 718.46s-.7 3.15-1 6a2.31 2.31 0 0 0 1.91 2.52 24.26 24.26 0 0 0 8.24.13 2.33 2.33 0 0 0 1.84-2.71c-.3-1.51-2-3.47-4.21-5.18Z",
    style: {
      fill: "url(#linear-gradient-184)",
      fillRule: "evenodd"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M972.26 659.32c.81.27 4.21 59.08 4.28 59.64a5.71 5.71 0 0 0 6.76.75c1.55-15.38 1.79-36.33 1.79-58.32Z",
    style: {
      fill: "url(#linear-gradient-185)",
      fillRule: "evenodd"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1004.21 658.51c1.15.65-3.16 59.72-5.15 60.28 0 0-2.16 2.3-5.89.1.74-19.2.67-38.63-1.8-58.32Z",
    style: {
      fill: "url(#linear-gradient-186)",
      fillRule: "evenodd"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M972.55 625s27.26-.62 33.88 1.2c0 0 .72 22.15-1 35.9a1.37 1.37 0 0 1-.95 1.14c-1.72.52-6.07 1.4-13.16-.07a1.36 1.36 0 0 1-1.08-1.33l.12-8.85a1.08 1.08 0 0 0-1.08-1.07h-1.61a1.07 1.07 0 0 0-1.07 1.13l.11 9a1.35 1.35 0 0 1-.83 1.34 23.75 23.75 0 0 1-14.38.83 1.35 1.35 0 0 1-1-1.22c-.86-10.85.2-23.94 2.05-38Z",
    style: {
      fill: "url(#linear-gradient-187)",
      fillRule: "evenodd"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M996.13 626.92s1.42 10.07 9.42 12.41l.43-11.06a63.44 63.44 0 0 0-9.85-1.35Z",
    style: {
      fill: "url(#linear-gradient-188)",
      fillRule: "evenodd"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1010 601.37-.74 30.25c-9.75.75-38.1 0-38.1 0-.87-5.15-1.54-17.55-2-29.65 0 0 .73-16.77-1.45-21.69a1.47 1.47 0 0 1 0-1.18 1.44 1.44 0 0 1 .91-.76 62.75 62.75 0 0 1 10.89-2c2-.19 4-.39 5.92-.39 12.87 0 23.45 2.75 23.45 3.48 5.87 3.57 1.12 21.94 1.12 21.94Z",
    style: {
      fill: "url(#linear-gradient-189)",
      fillRule: "evenodd"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m984 562.83-1.15 14.83s6.68 4.58 12.43.58l-1-13Z",
    style: {
      fill: "url(#linear-gradient-190)",
      fillRule: "evenodd"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M977.25 543.47s-6.47 26.44 8.14 27S1004 560 1004 560s2.66-18-.84-20.07-23.91-.86-25.91 3.54Z",
    style: {
      fill: "url(#linear-gradient-191)",
      fillRule: "evenodd"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M986.75 541.75s-17.08 4.67-18.25-3.75 5.42-14.5 10.42-12.08 7.5 6.25 10.33 4.08a10.25 10.25 0 0 1 13.33 1.75c4.17 4.67 15.9 12.71 4.47 23.29l-5.55 2s-4.33 1-3.17-3.33-1-9.49-3.16-9.24-7.5 1.86-8.42-2.72Z",
    style: {
      fill: "url(#linear-gradient-192)",
      fillRule: "evenodd"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1003 554.54s.77-6 3.68-4-1.74 9.06-3.64 9.37-.04-5.37-.04-5.37Z",
    style: {
      fill: "url(#linear-gradient-193)",
      fillRule: "evenodd"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M997.89 576.81c.59.07-.91 5.11-1 5.52-.65 2.27-1.15 4.57-3.24 6s-5.07 1.31-7.59 1.15a21.13 21.13 0 0 1-3.71-.53c-6.19-.91-3.1-10.62-2.87-12.55 2-.19 4-.37 5.92-.37 5.42-.03 12.49.78 12.49.78Z",
    style: {
      fill: "url(#linear-gradient-194)",
      fillRule: "evenodd"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1011.31 583a3.78 3.78 0 0 0-5.27-2.75c-2.87 1.28-5.62 3.85-3.14 8.89 4.38 8.92 6.06 44.8 6.06 44.8l4.19-.32c4.14-15.56.02-40.92-1.84-50.62Z",
    style: {
      fill: "url(#linear-gradient-195)",
      fillRule: "evenodd"
    },
    transform: "translate(-94.25 -69.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1011.37 630.35 1.78 3.24s2.15 5.07 2.17 8.62-4.89 4.66-6.57 4.71-1.89-1.63-.34-4.53a14.6 14.6 0 0 1 1.12-10.38Z",
    style: {
      fill: "url(#linear-gradient-196)",
      fillRule: "evenodd"
    },
    transform: "translate(-94.25 -69.15)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroImage);
export default __webpack_public_path__ + "static/media/hero-image.e1c19a002509dddec07bbf21986add44.svg";
export { ForwardRef as ReactComponent };